import { AgencyNewsEnum } from '@model/enum/agency-news.enum';
import { BilletOrderTypeEnum } from '@model/enum/billet-order-type';
import { HttpHeaders } from '@angular/common/http';
import { OrderEstrategyTypeEnum } from './../model/enum/order-estrategy-type.enum';
import { TypeOrderEnum } from '@model/enum/type-order.enum';
import { PlanFastTradeTypeEnum } from '@model/enum/plan-fasttrade-type.enum';

enum WORKSPACE_TYPE {
  Web = 1,
  Mobile = 2
}

export enum ALERT_TYPE {
  success = 'success',
  info = 'info',
  error = 'error',
  error_reject = 'error_reject',
  warn = 'warn',
  alert = 'alert'
}

export enum LOGIN_TYPE {
  LoginO = 'LoginO',
  LoginS = 'LoginS',
  LoginW = 'LoginW',
  LoginA = 'LoginA',
  LoginIAM = 'LoginIAM'
}

enum LAYOUT_TYPE {
  Dark = 'Dark',
  Light = 'Light',
  Custom = 'Custom'
}

enum TYPE_ORDER_TEXTS {
  Limited = 'Limitada',
  MarketProtected = 'Mercado com Proteção',
  Market = 'Mercado Limite'
}

export enum Profile {
  Client,
  Assessor
}

enum ELETRONIC_SIGNATURE_TYPES {
  virtual_keyboard = 'virtual_keyboard',
  string = 'string'
}

enum TERM_OPERATOR_TYPES {
  PDF = 0,
  IMG = 1,
  TEXT = 2,
  URL = 3
}

export class Constants {

  public static TOOLTIP_GUIDE =
    {
      cod: 1,
      onlineHeritageTitle: 'O Patrimônio online é composto apenas pelos ativos elegíveis a composição do Limite Operacional:',
      onlineHeritageResponse: [
        'Ações',
        'BTC (tomador e doador)',
        'Opções',
        'Resultado Termo',
        'Ajuste de Posição BM&F',
        'Garantias depositadas em Bolsa',
        'Tesouro Direto',
        'Títulos Públicos',
        'Títulos Privados (CDB / LCA / LCI / Debentures / CRI / CRA / LC',
        'Saldo em c/c',
        'Cotas de fundos com resgate até D1'
      ],
      operationalLimitTitle: 'Para definição do Limite Operacional são aplicados os seguintes fatores:',
      operationalLimitResponse:
      {
        header: [
          'Ativo', 'Fator'
        ],
        value: [
          { title: 'Recursos depositados em conta corrente (saldo disponível + projetado)', value: '100%' },
          { title: 'Ações', value: 'Deságio Bolsa' },
          { title: 'Título Público', value: '100%' },
          { title: 'Tesouro Direto', value: '100%' },
          { title: 'Título Privado', value: '' },
          { title: '- CDB / LCA / LCI', value: '80%' },
          { title: '- Debênture / CRA / CRI / LC', value: '50%' },
          { title: 'Cotas de fundos de investimentos com resgate até D1', value: '100%' },
        ]
      }
    };

  public static INFO_LOGIN_AMARIL = [
    { paragrafh: 1, text: 'O código secreto (senha) a ser escolhido pelo usuário e gravado nos sistemas é de uso pessoal, intransferível e de conhecimento exclusivo. É da inteira responsabilidade do usuário todo e qualquer prejuízo causado pelo fornecimento de sua senha pessoal a terceiros, independente do motivo.' },
    { paragrafh: 2, text: 'TODA COMUNICAÇÃO ATRAVÉS DA REDE MUNDIAL DE COMPUTADORES ESTÁ SUJEITA A INTERRUPÇÕES OU ATRASOS, PODENDO IMPEDIR OU PREJUDICAR O ENVIO DE ORDENS OU A RECEPÇÃO DE INFORMAÇÕES ATUALIZADAS (I) DE ‘STATUS’ DAS ORDENS; (II) DE POSIÇÕES DE CUSTÓDIA, DE OPERAÇÕES E DE LIMITES; E (III) DE COTAÇÃO DE ATIVOS.' },
    { paragrafh: 3, text: 'Após 30 minutos sem atividades sua página de negociação automaticamente expirará, desconectando-se do sistema de negociação pela rede mundial de computadores, para acessá-lo novamente basta abrir a página novamente e efetuar seu login.' },
    { paragrafh: 4, text: 'A Corretora Amaril Franklin CTV Ltda, está autorizada a funcionar pelo Banco Central do Brasil, conforme Carta Patente n° A-67/2279.' },
  ];

  public static textDefaultLogin = 'Toda transmissão de ordem por meio digital está sujeita a interrupções ou atrasos, podendo impedir ou prejudicar o envio de ordens ou a recepção de informações atualizadas, nos termos da Instrução CVM 612.';

  public static MSG_LOGIN_TRANSITION_TITLE_DEFAULT = 'Home Broker, aqui vou eu!';
  public static MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT = 'Só mais alguns segundos e você vai acessar nossa Plataforma!';

  public static MSG_TRADE_CHART_PAD_WARNING = 'Este PAD apenas exibe a posição atual do cliente, bem como dá opção de comprar e vender de forma mais ágil. As ordens e posição não são exibidas no gráfico.';

  public static SIDEBAR_MENU_DEFAULT_LABEL = {
    RANKING: 'RANKING',
    EDUCATIONAL: 'MATERIAL EDUCACIONAL',
    CLIENTS: 'CLIENTES',
    MY_BALANCE: 'PATRIMÔNIO',
    HISTORY: 'ORDENS',
    CUSTODY: 'CUSTÓDIA',
    GRAPH: 'GRÁFICOS',
    NEWS: 'NOTÍCIAS',
    BROKERAGE: 'NOTA DE CORRETAGEM',
    EXTRACT: 'EXTRATO',
    DEPOSIT: 'DEPÓSITO / RESGATE'
  };

  public static MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT = {
    title: 'Comunicado aos clientes Home Broker',
    content: '<h2>Retirada de recursos disponíveis em conta</h2><br>' +
      '<h3>Horário de funcionamento em dias úteis</h3>' +
      '<p><strong>Até às 13h:</strong> Sua retirada será efetivada em sua conta bancária cadastrada, até o final do mesmo dia útil;</p>' +
      '<p><strong>Após às 13h:</strong> Sua retirada será efetivada em sua conta bancária cadastrada, até o fim do próximo dia útil;</p><br>' +
      '<h3>Horário de funcionamento no final de semana ou feriado</h3>' +
      '<p>O crédito irá ocorer em sua conta bancária cadastrada, no decorrer do próximo dia útil.</p>'
  };

  public static LINK_DOWNLOAD_FT_DESKTOP = `https://files.cedrotech.com/Downloads/Cedro/FastTrade/iFastTrade.exe`;
  public static LINK_DOWNLOAD_FT_ANDROID = `https://play.google.com/store/apps/details?id=br.com.cedrotech.fastmobile&hl=pt_BR`;
  public static LINK_DOWNLOAD_FT_IOS = `https://apps.apple.com/br/app/fast-trade/id1421909782`;

  public static LINK_POLICY_CVM = 'http://www.cvm.gov.br/';
  public static LINK_SAC_CVM = 'https://www.gov.br/cvm/pt-br/canais_atendimento/consultas-reclamacoes-denuncias';
  public static LINK_SAC_MRP = 'https://www.bsmsupervisao.com.br/ressarcimento-de-prejuizos/como-funciona';
  public static LINK_POLICY_BMF_BOVESPA = 'http://www.b3.com.br/pt_br/';
  public static LINK_URL_RANKED = 'https://data.fastmarkets.com.br/ranking/desafiodeinvestimentos';
  public static LINK_URL_RANKED_EDUCATIONAL = 'https://lp.plataformafasttrade.com.br/materiais-ricos-fast-trade';


  public static WHITELABEL = [
    { // 'FASTTRADE'
      system: {
        cod: 1, whitelabel_name: 'FASTTRADE', login_type: 'LoginS', api: 'FACADE', systemName: 'Fast Trade', isMultiBroker: true, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: false, showBtnNewAccount: true,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.DAYTRADE, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: true, showQuotation: true },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'servicedesk@cedrotech.com', urlHbWhitelabel: 'https://plataformafasttrade.com.br/',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 34 3239-0003', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'servicedesk@cedrotech.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (34) 3239-0003' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'PI'
      system: {
        cod: 2, whitelabel_name: 'PI', login_type: 'LoginA', api: 'ADAPTER', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: false, textButtonTransition: '', title: Constants.MSG_LOGIN_TRANSITION_TITLE_DEFAULT, subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false,
        showAfterLoginMessage: true, enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'pioneiros@somospi.com.br', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '0800 878 3185', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'pioneiros@somospi.com.br' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '0800 878 3185' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'RB'
      system: {
        cod: 3, whitelabel_name: 'RB', login_type: 'LoginW', api: 'WSO2', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: true, textButtonTransition: '', title: '', subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: false, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: true
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: true, showPositionHistoryBov: true },
      contact: {
        email: 'investimentos@rbinvestimentos.com', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 (11) 3127-2700', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'suporterv@rbinvestimentos.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (11) 3127-2752' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '0800 942 4685' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: 'https://www.gov.br/cvm/pt-br/canais_atendimento/consultas-reclamacoes-denuncias' },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: 'https://www.bsmsupervisao.com.br/ressarcimento-de-prejuizos/como-funciona' },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: false, balanceProjectedOnline: false, detailBalanceProjectedOnline: false, patrimonyOnline: false,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: false },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'FASTTRADE'
      system: {
        cod: 4, whitelabel_name: 'FASTTRADE', login_type: 'LoginW', api: 'WSO2', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: true, showQuotation: true },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'servicedesk@cedrotech.com', urlHbWhitelabel: 'https://plataformafasttrade.com.br/',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 34 3239-0003', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'servicedesk@cedrotech.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (34) 3239-0003' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'CEDRO'
      system: {
        cod: 5, whitelabel_name: 'CEDRO', login_type: 'LoginO', api: 'FACADE', systemName: 'Fast Trade', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: true, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: true,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: true, showQuotation: true },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'servicedesk@cedrotech.com', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 34 3239-0003', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'servicedesk@cedrotech.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (34) 3239-0003' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'DAYCOVAL'
      system: {
        cod: 6, whitelabel_name: 'DAYCOVAL', login_type: 'LoginA', api: 'ADAPTER', systemName: '', isMultiBroker: false, isThemeDarkDefault: true,
        isTransition: { active: true, showBtnTransition: true, textButtonTransition: 'DAYCONECT', title: Constants.MSG_LOGIN_TRANSITION_TITLE_DEFAULT, subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false,
        showAfterLoginMessage: true,
        enableLoginMarketData: true,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: 'Estamos em manutenção.', subTitle: 'Efetue o login novamente ou tente novamente mais tarde.', hiddenButtonLogin: true },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: true, showPositionHistoryBov: true },
      contact: {
        email: 'dayconnect@bancodaycoval.com.br', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Suporte técnico', phoneNumber: '0300-777-2020', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Outras informações', phoneNumber: '0300 111 0500', phoneDesc: '(Equipe do help para assuntos de acesso e senha)',
          phoneInfo: 'Suporte técnico', isWhatsApp: false, moreInfo: 'Mesa ou outras informações', phoneMoreInfo: '0300 111 0500', moreInfoDesc: '',
          sacInfo: 'SAC', sacPhone: '0800 775 0500', sacInfoDesc: '(Reclamação e cancelamento)',
          ombudsman: 'Ouvidoria', phoneOmbudsman: '0800 777 0900',
          HearingImpaired: 'Deficiente Auditivo', phoneHearingImpaired: '0800 775 2005'
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'dayconnect@bancodaycoval.com.br' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '0300 111 0500' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '0800 777 0900' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'StoneX'
      system: {
        cod: 7, whitelabel_name: 'StoneX', login_type: 'LoginIAM', api: 'ADAPTER', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: true
      },
      login: {
        showInfoLogin: true, showHelpLogin: true, textFristInfo: Constants.textDefaultLogin, linkInfo: 'https://dtvm.stonex.com', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: true,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: true, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: '', urlHbWhitelabel: 'https://dtvm.stonex.com',
        supportPhone: { phoneTitle: 'Atendimento: ', phoneNumber: '(11) 3509 5440', infoService: 'Seg. a Sexta. das 8:45 às 18:15', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '0800 942 4685', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'dg-itbrazil@stonex.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (11) 3509 5440' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '0800 942 4685' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'TRINUS'
      system: {
        cod: 8, whitelabel_name: 'TRINUS', login_type: 'LoginW', api: 'WSO2', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: true, textButtonTransition: '', title: '', subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'contato@tgcore.com.br', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 (62) 3773-1500', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'ouvidoria@trinusco.com.br' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (62) 3773-1500' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '0800 520 3302' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'EMPIRICUS'
      system: {
        cod: 9, whitelabel_name: 'EMPIRICUS', login_type: 'LoginA', api: 'ADAPTER', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: Constants.MSG_LOGIN_TRANSITION_TITLE_DEFAULT, subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false,
        showAfterLoginMessage: true, enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: 'Seu login Empiricus (CPF)', tooltipUsername: 'Seu login Empiricus (CPF)', inputPassword: 'Sua senha Empiricus', tooltipPassword: 'Sua senha Empiricus', inputForgotPassword: 'Esqueci minha senha', linkForgotPassword: 'https://portal.empiricusinvestimentos.com.br/esqueci-senha' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: '', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: '', phoneNumber: '', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: '', phoneNumber: '', phoneDesc: '',
          phoneInfo: 'Suporte técnico', isWhatsApp: false, moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '',
          sacInfo: 'SAC', sacPhone: '', sacInfoDesc: '',
          ombudsman: 'Ouvidoria', phoneOmbudsman: '',
          HearingImpaired: 'Deficiente Auditivo', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: '' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: false, propNames: { availableBalanceStr: 'saldoDisponivel', operatingLimit: 'limiteOperacionalVitreo', balanceD1: 'saldoD1', balanceD2: 'saldoD2' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'RANKING'
      system: {
        cod: 10, whitelabel_name: 'CICLO DE INVESTIMENTOS', login_type: 'LoginS', api: 'FACADE', systemName: 'Fast Trade', isMultiBroker: true, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: false, showBtnNewAccount: true,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: true, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: 'servicedesk@cedrotech.com', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 34 3239-0003', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'servicedesk@cedrotech.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 (34) 3239-0003' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'Amaril Franklin CTV LTDA'
      system: {
        cod: 11, whitelabel_name: 'Amaril Franklin CTV LTDA', login_type: 'LoginO', api: 'FACADE', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: true, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: true, textFristInfo: '', textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: true, text: Constants.INFO_LOGIN_AMARIL }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: false, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: true,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: true, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: false, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: '', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: 'homebroker@amarilfranklin.com.br', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'homebroker@amarilfranklin.com.br' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: false, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: false, fixedIncomeStr: false, fundsStr: false, clubsStr: false, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'GUIDE'
      system: {
        cod: 12, whitelabel_name: 'GUIDE', login_type: 'LoginA', api: 'ADAPTER', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL, MY_BALANCE: 'FINANCEIRO' },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.DAYTRADE, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      contact: {
        email: '', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '', infoService: '', isWhatsApp: false },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: '' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: 'FINANCEIRO', infoMessage: {
          active: true, message: 'Caro cliente,<br>As informações sobre seu Saldo e Patrimônio total podem ser consultadas via Portal do cliente ou App Guide investimentos. <br>Esta plataforma é exclusiva para negociações de renda variável.'
        },
        balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: false,
        tooltipsPatrimony: { tooltip: Constants.TOOLTIP_GUIDE, isTooltip: true }, operationalLimit: true, lossProfitDayTrade: true, bmfAdjustments: true, position: false,
        bmfLeveragedLimitStr: true, fundLimitStr: false, fixedIncomeLimitStr: false, directTreasuryLimitStr: false, withdrawLimitStr: false, withdrawLimitUsedStr: false,
        bmfLimitStr: false, optionLimitStr: false, cashLeveragedLimitStr: true, optionsLeveragedLimitStr: true, operationalLimitStr: false,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'SINGULARE'
      system: {
        cod: 13, whitelabel_name: 'SINGULARE', login_type: 'LoginS', api: 'FACADE', systemName: 'Singulare Invest', isMultiBroker: true, isThemeDarkDefault: false,
        isTransition: { active: false, showBtnTransition: false, textButtonTransition: '', title: '', subTitle: '' }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      contact: {
        email: '', urlHbWhitelabel: '',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: '' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: false, showBtnNewAccount: true,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: false, showSideBarBrokerageNote: false, showSideBarExtract: false, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.DAYTRADE, getStrategiesService: true, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: false
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: true, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: false, showPositionHistoryBov: false },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: true, balanceProjectedOnline: true, detailBalanceProjectedOnline: true, patrimonyOnline: true,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: true },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
    { // 'CEDRO - DEMO'
      system: {
        cod: 14, whitelabel_name: 'CEDRO - DEMO', login_type: 'LoginW', api: 'WSO2', systemName: '', isMultiBroker: false, isThemeDarkDefault: false,
        isTransition: { active: true, showBtnTransition: true, textButtonTransition: '', title: '', subTitle: Constants.MSG_LOGIN_TRANSITION_SUBTITLE_DEFAULT }, getSystemTermUse: false, showAfterLoginMessage: true,
        enableLoginMarketData: false,
        selectRedemptionAccount: false
      },
      login: {
        showInfoLogin: true, showHelpLogin: false, textFristInfo: Constants.textDefaultLogin, textSecondInfo: '', linkInfo: '', showPolicyCvmAndBrowser: true, showBtnNewAccount: false,
        showInfoTextLogin: { active: false, text: '' }, messageLogout: { title: '', subTitle: '', hiddenButtonLogin: false },
        textInputLogin: { inputUsername: '', tooltipUsername: '', inputPassword: '', tooltipPassword: '', inputForgotPassword: '', linkForgotPassword: '' }
      },
      sidebar: {
        showHelpArea: false, showProfileSuitabilityName: true, showSideBarBrokerageNote: true, showSideBarExtract: true, showSideBarMenuDeposit: false,
        customSidebarLabel: { ...Constants.SIDEBAR_MENU_DEFAULT_LABEL },
      },
      billet: {
        orderStrategy: OrderEstrategyTypeEnum.POSITION, getStrategiesService: false, isTypeBilletStopSimultaneousOrOco: BilletOrderTypeEnum.SIMULTANEOUS, advisorCanAcceptTerm: true
      },
      worksheet: { showWorksheetShareDefault: true, }, password: { isActive: false, showNegotiation: false, showQuotation: false },
      custody: { showPositionBovespa: true, showPositionBMF: true, showPositionEarnings: true, showPositionHistoryBov: true },
      contact: {
        email: 'servicedesk@cedrotech.com', urlHbWhitelabel: 'https://plataformafasttrade.com.br/',
        supportPhone: { phoneTitle: 'Atendimento', phoneNumber: '+55 34 3239-0003', infoService: '', isWhatsApp: true },
        ombudsmanPhone: {
          phoneTitle: 'Ouvidoria', phoneNumber: '', phoneDesc: '', isWhatsApp: false,
          moreInfo: '', phoneMoreInfo: '', moreInfoDesc: '', sacInfo: '', sacPhone: '', sacInfoDesc: '', ombudsman: '', phoneOmbudsman: '',
          HearingImpaired: '', phoneHearingImpaired: ''
        },
        settingsSupportChannels: {
          primary: [
            { icon: 'mail', description: 'E-mail para suporte:', contact: 'servicedesk@cedrotech.com' },
            { icon: 'smartphone', description: 'Telefone para contato:', contact: '+55 34 3239-0003' },
            { icon: 'smartphone', description: 'Ouvidoria', contact: '' },
          ],
          others: [
            { description: 'CVM', linkText: 'Dúvidas e Denúncias (SAC-CVM)', link: Constants.LINK_SAC_CVM },
            { description: 'MRP', linkText: 'Ressarcimento de prejuízos', link: Constants.LINK_SAC_MRP },
          ]
        },
      },
      patrimony: {
        customTitle: null, infoMessage: { active: false, message: null }, balanceAccount: false, balanceProjectedOnline: false, detailBalanceProjectedOnline: false, patrimonyOnline: false,
        tooltipsPatrimony: { tooltip: '', isTooltip: false }, operationalLimit: true,
        lossProfitDayTrade: true, bmfAdjustments: true, position: true, bmfLeveragedLimitStr: true, fundLimitStr: true, fixedIncomeLimitStr: true,
        directTreasuryLimitStr: true, withdrawLimitStr: true, withdrawLimitUsedStr: true, bmfLimitStr: true, optionLimitStr: true, cashLeveragedLimitStr: true,
        optionsLeveragedLimitStr: true, operationalLimitStr: true,
        positionDetail: { onlineCustodyStr: true, earningsStr: true, guaranteeStr: true, directTreasuryStr: true, fixedIncomeStr: true, fundsStr: true, clubsStr: true, balanceProjOnline: false },
        cardRest: { showlayoutFullSocket: true, propNames: { availableBalanceStr: '', operatingLimit: '', balanceD1: '', balanceD2: '' } }
      },
      deposit: { announcementModal: { active: true, ...Constants.MODAL_DEPOSIT_DEFAULT_ANNOUNCEMENT } }
    },
  ];

  public static ELETRONIC_SIGNATURE_TYPES = ELETRONIC_SIGNATURE_TYPES;
  public static TERM_OPERATOR_TYPES = TERM_OPERATOR_TYPES;
  public static TERM_OPERATOR_ERROR = 'Não foi possível validar o TERMO.';
  public static TERM_OPERATOR_TYPE_STRING_TITLE = 'Termos e condições';
  public static TERM_OPERATOR_TYPE_STRING_TERM = 'O SR/SRA possui ciência de que o <b>perfil de risco deste produto, operação ou serviço de investimento não é ' +
    'compatível com o seu perfil de investidor</b>, identificado anteriormente por meio de questionário respondido. Contudo, deseja aplicar neste produto e em outros ' +
    'de riscos equivalente, estando de acordo com os riscos inerentes a este tipo de investimentos.';

  public static VERSISON_SYSTEM = 'VERSION_HB';

  public static LOGIN_MSG_STORE = 'Caso não consiga efetuar o login na plataforma Fast Trade e seu login foi criado após 01/07/2022,' +
    ' tente acessar através do botão MINHA CONTA ou entre em contato conosco pelos nossos canais de atendimentos.';
  public static LOGIN_MSG_TITLE_MULTI_BROKER = 'Faça seu login';
  public static LOGIN_MSG_SUBTITLE_MULTI_BROKER = 'Aproveite uma das plataformas de negociação mais ágil, moderna e prática do mercado financeiro.';
  public static LOGIN_MSG_TITLE = 'Seja bem vindo!';
  public static LOGIN_MSG_SUBTITLE = '';
  public static LOGIN_MSG_TITLE_RANKING = 'Desafio de Investimentos';
  // tslint:disable-next-line:max-line-length
  public static LOGIN_MSG_SUBTITLE_RANKING = 'Bem-vindo ao primeiro Desafio de Investimentos da Bolsa de Valores (B3), realizado através de uma parceria do Fast Trade, Levante Ideias de Investimentos e Guide Investimentos.';
  public static LOGIN_MSG_TITLE_AUTHENTICATION = 'Dupla Autenticação!';
  // tslint:disable-next-line:max-line-length
  public static LOGIN_MSG_SUBTITLE_AUTHENTICATION = '';
  public static LOGIN_EXPIRED_PASSWORD = 'Senha expirada';
  public static DEFAULT_SOURCE_ADRESS_WSO2_CLIENT = 'Cliente';
  public static DEFAULT_SOURCE_ADRESS_WSO2_ASSESSOR = 'Assessor';
  public static DEFAULT_SOFTWARE_NAME_RANKING = 'Desafio';
  public static DEFAULT_SOFTWARE_NAME = 'FTWEB_BROKER';
  public static DEFAULT_APP_NAME = 'FASTWEB';
  public static DEFAULT_APP_NAME_ADAPTER = 'web';
  public static BROKER_MERCBITCOIN = 'mercbitcoin';

  public static DATE_UPDATE_VOLUME = 'HH:mm:ss';
  public static DATE2_DDMMYYYY = 'ddMMyyyy';
  public static DATE_DDMMYYYY = 'dd-MM-yyyy';
  public static DATE_NEWS_YYYYMMDD = 'yyyy-MM-dd';
  public static DATE_NEWS_BEFORE = 'T23:59:59';
  public static DATE_NEWS_AFTER = 'T00:00:00';
  public static DAY_MINUTE_IN_MILISECONDS = (1000 * 60 * 60 * 24);

  public static SIDEBAR_HELP_TITLE = 'Precisa de ajuda?';
  public static SIDEBAR_HELP_TITLE_RANKING = 'Precisa de ajuda?';
  public static SIDEBAR_HELP_PHONE1 = '+55 11 3014-0200';
  public static SIDEBAR_HELP_PHONE2 = '+55 34 3239-0000';
  public static SIDEBAR_HELP_WHATSAPP = '+55 34 3239-0003';
  public static SIDEBAR_HELP_WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone={{phone}}&text=Olá!';
  public static SIDEBAR_HELP_EMAIL = 'servicedesk@cedrotech.com';

  public static ID_SIDE_MENU_ORDER = 2;

  public static CREATE_NEW_ACCOUNT_API = 'register';
  public static CREATE_NEW_ACCOUNT_RANKING = 'ciclo-investimentos/register';
  public static CREATE_NEW_ACCOUNT_CEDRO = 'http://cadastrodigital.cedrotech.com/cadastro';
  public static CREATE_NEW_ACCOUNT_RB = 'https://uat.rbinvest.com.br/cadastro';

  public static testAccount = '789789';
  public static TYPE_ORDER_TEXTS = TYPE_ORDER_TEXTS;
  public static LOGIN_TYPE = LOGIN_TYPE;
  public static ALERT_TYPE = ALERT_TYPE;
  public static LAYOUT_TYPE = LAYOUT_TYPE;
  public static LAYOUT_THEME_DARK = 'LAYOUT_THEME_DARK';
  public static COOKIE_USER = 'UL';
  public static COOKIE_TOKEN_WEBAPI = 'TKNAPI';
  public static COOKIE_TOKEN_WEBFEEDER = 'TKNWF';
  public static COOKIE_TOKEN_WEBFEEDER_GRAPHIC = 'TKNWF_GRAPHIC';
  public static COOKIE_TOKEN_WEBFEEDER_NEGOTIATION = 'TKNWF_NEGOT';
  public static COOKIE_HB_ACCOUNT = 'HBA';
  public static COOKIE_HB_ACCOUNT_ID = 'HBA_ID';
  public static COOKIE_HB_ASSESSOR_ID = 'HBA_ASSESSOR_ID';
  public static COOKIE_HB_USER_ID = 'HBA_USER_ID';
  public static COOKIE_HB_ACCOUNT_NAME = 'HBA_USERNAME';
  public static COOKIE_HB_ACCOUNT_EMAIL = 'HBA_EMAIL';
  public static COOKIE_HB_CURRENTUSER = 'HBA_CURRENT_USER';
  public static COOKIE_HB_ABA = 'aba0';
  public static COOKIE_MESSAGE = 'MSG';
  public static COOKIE_TOKEN_EXPIRATION = 'TKNEXP';
  public static COOKIE_TOKEN_TIMER_EXPIRATION = 'TOKEN_TIMER_EXPIRATION';
  public static COOKIE_GUID_USER = 'GUID_USER';
  public static COOKIE_USER_LOGIN_TYPE = 'USER_LOGIN_TYPE';
  public static COOKIE_STOP_VALID = 'STOP_VALID';

  public static COOKIE_CONFIG_CARDS_WKS = 'CONFIG_CARDS_WKS';

  public static COOKIE_REFRESH_PAGE = 'REFRESH_PAGE';
  public static COOKIE_FIRST_MODAL_NOTIFICATION = 'FIRST_MODAL_NOTIFICATION';

  public static COOKIE_IS_ASSESSOR = 'IS_ASSESSOR';
  public static COOKIE_SYSTEM_ACCOUNT_NAME = 'SYSTEM_USERNAME';
  public static COOKIE_ASSESSOR_LIST_CLIENT = 'ASSESSOR_LIST_CLIENT';
  public static COOKIE_ASSESSOR_CLIENT_SELECTED = 'ASSESSOR_CLIENT_SELECTED';
  public static COOKIE_CLIENT_PROFILE_NAME = 'CLIENT_PROFILE_NAME';

  public static COOKIE_USER_IDENTIFIER = 'USER_IDENTIFIER';
  public static COOKIE_TOKEN_REFRESH_WEBAPI = 'TKNAPIREFRESH'; // Cedro Accounts
  public static COOKIE_SCOPE = 'scope';                        // Cedro Accounts
  public static COOKIE_TOKEN_TP = 'token_type';                // Cedro Accounts
  public static COOKIE_TOKEN_LAST_REFRESHED = 'lastRefreshed'; // Cedro Accounts

  public static LOGIN_A = 'LoginA';
  public static LOGIN_O = 'LoginO';
  public static LOGIN_S = 'LoginS';
  public static LOGIN_W = 'LoginW';

  public static WKS_USER_PROFILE = 'userperf01';
  public static WKSHT_USER_PROFILE = 'fasttradeworkspacedefault';
  public static WKSHT_PLAN_DEFAULT = 'Nova Planilha';

  public static WKS_USER_NAME_DEFAULT_PROFILE = 'Padrão';
  public static WKS_NAME_OFFLINE = 'default';

  public static LOCAL_TRANSITION = 'LOCAL_TRANSITION';
  public static COOKIE_STORAGE_AUTH = 'USER_AUTH';
  public static COOKIE_STORAGE_AUTH_ADAPTER = 'USER_AUTH_ADAPTER';
  public static LOCAL_COOKIE_STORAGE_AUTH = 'LOCAL_AUTH';
  public static LOCAL_STORAGE_COMMON = 'LOCAL_COMMON';
  public static LOCAL_STORAGE_TRANSITION = 'LOCAL_TRANSITION';
  public static LOCAL_STORAGE_USER_PREFERENCES = 'LOCAL_USER_PREFERENCES';
  public static SESSION_STORAGE_AFTER_LOGIN_MESSAGE = 'AFTER_LOGIN_MESSAGE';
  public static SESSION_STORAGE_SYMBOL_INFORMATION = 'SYMBOL_INFORMATION';

  public static COOKIE_HB_ADVISOR_GESTOR_CAN_ACCEPT_TERM = 'ADVISOR_GESTOR_CAN_ACCEPT_TERM';
  public static COOKIE_HB_LOGIN_TYPE_ENABLED = 'HB_LOGIN_TYPE_ENABLED';
  public static COOKIE_HB_BROKER_ACCOUNT_SELECTED = 'HB_BROKER_SELECT';
  public static COOKIE_HB_BROKER_USER_INFO_SELECTED = 'HB_BROKER_USER_INFO_SELECTED';
  public static COOKIE_HB_BROKER_ACCOUNT_LIST = 'HB_BROKER_ACCOUNT_LIST';
  public static COOKIE_HB_BROKER_ACCOUNT = 'HB_BROKER';
  public static COOKIE_HB_BROKER_CONNECTED = 'HB_BROKER_CONNECTED';
  public static COOKIE_HB_LOGIN_TYPE = 'HB_LOGIN_TYPE';
  public static COOKIE_HB_USER_MULTI = 'MULT_';
  public static COOKIE_HB_USER_LOGIN_MARKET = 'LOGIN_MARKET';
  public static COOKIE_HB_TYPE_ASSESSOR = '1'; // 1 = Assessor
  public static COOKIE_HB_TYPE_BROKER = '2'; // 2 = Corretora
  public static COOKIE_HB_TYPE_OFFILINE = '3'; // 3 = Não conectado
  public static COOKIE_HB_TYPE_CEDRO = '4'; // 4 = Cedro (WF)
  public static COOKIE_HB_TYPE_SIMULATOR = '5'; // 5 = Simulador (WF)
  public static COOKIE_HB_TYPE_MARKET_DATA = '6'; // 5 = Simulador (WF)

  public static COOKIE_CONNECT_LOGIN_TYPE = [
    { cod: 1, type: 'ACCESSOR', desc: 'Assessor' },
    { cod: 2, type: 'BROKER', desc: 'Corretora' },
    { cod: 3, type: 'MULRIBROKERR', desc: 'Multibroker' },
    { cod: 4, type: 'CEDRO', desc: 'Cedro (WF)' },
    { cod: 5, type: 'SIMULATOR', desc: 'Simulador (WF)' },
    { cod: 6, type: 'MARKETDATA', desc: 'Market Data' },
  ];

  public static ONBOARD_MSG_01 = 'Sua conta foi criada com sucesso. Em até 15 (quinze) minutos você receberá no seu e-mail os dados de acesso.';
  public static ONBOARD_MSG_02 = 'Sua conta está sendo criada. Em até 15 (quinze) minutos você receberá no seu e-mail o status da criação.';
  public static ONBOARD_MSG_03 = '<h1 class="email">Verifique seu e-mail!</h1><br>' +
    ' Você está a um passo de completar o seu cadastro! Em breve você receberá um e-mail de confirmação.<br>' +
    'Fique atento(a) a sua caixa de entrada e ao spam.';

  public static BROKER_SIDE_BAR_OFFLINE = 'Você não está conectado em NEGOCIAÇÃO';
  public static BROKER_SIDE_BAR_SIMULATOR = 'Você já está conectado no SIMULADOR.';
  public static BROKER_SIDE_BAR_MARKET_DATA = 'Login Market Data';

  public static COOKIE_HB_CONFIG_MULTI_BROKER = 'MULTI_BROKER';
  public static COOKIE_HB_SHOW_STATUS_OMS = 'SHOW_STATUS_OMS';
  public static BROKER_MSG002 = 'Ocorreu um erro durante a operação, verifique as informações fornecidas e tente novamente.' +
    ' Caso o problema persista, entre em contato conosco.';
  public static BROKER_MSG004 = 'As informações inseridas estão incorretas.';
  public static BROKER_MSG005 = 'Usuário autenticado com sucesso no simulador.';
  public static BROKER_MSG006 = 'Ocorreu um erro ao buscar as corretoras vinculadas ao seu usuário.'
    + ' Tente novamente, caso o problema persistir entre em contato conosco.';
  public static BROKER_MSG007 = 'Não conseguimos localizar o dados vinculados na corretora selecionada. '
    + 'Verifique as informações e tente novamente.';
  public static BROKER_MSG008 = 'Por favor, selecione uma corretora';
  public static BROKER_MSG009 = 'Ocorreu um erro ao Buscar os Termos vinculadas ao seu usuário. Tente novamente, caso o problema persistir entre em contato conosco.';
  public static BROKER_MSG010 = 'Ocorreu um erro ao Salvar os Termos vinculadas ao seu usuário.';
  public static BROKER_MSG011 = 'Dados inválidos ou incorretos. Tente novamente mais tarde, caso o erro persista entre em contato conosco!';
  public static BROKER_MSG012 = 'Ocorreu um erro ao conectar aos servidores de negociação. Tente novamente, caso o problema persistir entre em contato conosco.';
  public static BROKER_MSG013 = 'Solicitação de recuperação de usuário e senha enviado para email cadastrado!';
  public static BROKER_MSG014 = 'Ocorreu um erro para SALVAR as Configurações do gráfico. Tente novamente, caso o problema persistir entre em contato conosco.';

  public static MSG_AFTER_LOGIN_EFFECTIVE_DATE = '<br/><br/><strong>Esta menssagem será exibida até o dia {{date}}.<strong>';

  public static CLOSED_MARKET_MESSAGE = 'Olá, no momento o mercado está fechado.';
  public static EMPTY_MESSAGE = 'Não há dados do ativo.';

  public static CEP_NOT_FOUND_MESSAGE = 'CEP não encontrado, por favor tente novamente.';
  public static CEP_FOUND_TITLE = 'CEP encontrado';
  public static CEP_FOUND_MESSAGE_MODAL = 'Você gostaria de substituir os valores que você digitou pelos valores do CEP encontrado?';

  public static UNDERAGE_REGISTER_MESSAGE = 'Proibido o cadastro para menores de idade.';
  public static INVALID_DATE_REGISTER_MESSAGE = 'Data inválida.';

  public static COOKIE_CURRENT_BROKER = 'BRK';
  public static COOKIE_IP = 'IP';
  public static COOKIE_TOKEN_BROKER_WEBFEEDER = 'TKCBRK';
  public static COOKIE_TOKEN_BROKER_EXPIRATION = 'TKNBRKEXP';

  public static COOKIE_BILLET_CLOSED_MODAL = 'BILLET_LAST_CONFIG';
  public static COOKIE_WORKSPACE = 'WKS';

  public static COOKIE_ENCRYPT_SECRET_KEY = '91406374-df51-4283-8180-006fe53b80e4';
  public static COOKIE_IS_LOGIN_MULTIBROKER = 'IS_LOGIN_MULTIBROKER';
  public static COOKIE_LOGIN_MARKET_DATA = 'TKN_USER_MARKET_DATA';

  // direction: 1 = compra / 2 = venda
  public static ORDER_DIRECTION_BUY = 1;
  public static ORDER_DIRECTION_SELL = 2;
  // typeOrder: 1 = boleta / 2 daytrade
  public static OPEN_POSITION_TRADE = 'POSITION';
  public static OPEN_DAY_TRADE = 'DAYTRADE';

  // action: 1 = New, 2=Edit, 3= Reenvio
  public static ACTION_NEW = 1;
  public static ACTION_EDIT = 2;
  public static ACTION_RESEND = 3;

  public static MARKET_NAMES = {
    1: 'Bovespa',
    2: 'Dow Jones',
    3: 'BM&F',
    4: 'Índices',
    5: 'Money',
    6: 'Soma',
    7: 'Forex',
    8: 'Indicators',
    9: 'Others',
    10: 'Nyse',
    11: 'Bats',
    12: 'Nasdaq',
    14: 'BVL',
    15: 'SPIndexes',
    16: 'Liffe',
    17: 'Euronext Indices',
    18: 'CME',
    19: 'CME Mini',
    30: 'Bitcoin'
  };
  public static MARKET_BOVESPA = 'XBSP';
  public static MARKET_BOVESPA2 = 'BVSP';
  public static MARKET_BMF = 'XBMF';
  public static MARKET_BMF2 = 'BMF';
  public static MARKET_CODE_BOVESPA = 1;
  public static MARKET_CODE_BMF = 3;
  public static ORDER_SIDE_BUY = 'BUY';
  public static ORDER_SIDE_SELL = 'SELL';

  public static MARKET_NAME_BOVESPA = 'Bovespa';
  public static MARKET_NAME_BMF = 'BM&F';

  public static ORDER_TYPE_MARKET = 'MARKET';
  public static ORDER_TYPE_LIMITED = 'LIMITED';
  public static ORDER_TYPE_START = 'START';
  public static ORDER_TYPE_STOP = 'STOP';
  public static ORDER_TYPE_ON_CLOSE = 'ONCLOSE';
  public static ORDER_TYPE_PROTECTED_MARKET = 'MARKETPROTECTED';

  public static LANGUAGE_PORTUGUESE = 'pt-br';
  public static SYMBOL_PORTUGUESE = 'BRL';

  public static INTERVAL_VOLUME_AT_PRICE = 60000;

  public static QTD_NEWS_WKS = 20;
  public static QTD_NEWS_SIDE_BAR = 10;

  public static CODE_ORDER_TYPE_NORMAL = '1';
  public static CODE_ORDER_TYPE_STOP = '2';

  public static TRADINGVIEW_DEFAULT_TYPE = 1;

  public static INDEX_HIGH_LOW_DAY = 'ibov';
  public static SERVICE_HIGH_LOW_DAY = [
    { index: 0, service: 'highList', identifier: 'highListIndex' },
    { index: 1, service: 'fallList', identifier: 'fallListIndex' },
    { index: 2, service: 'highVolumeList', identifier: 'highVolumeListIndex' },
    { index: 3, service: 'fallVolumeList', identifier: 'fallVolumeListIndex' },
  ];

  public static ORDER_TYPES = [
    { cod: '1', desc: 'Normal', webfeeder: 'Limited' }
  ];
  public static TIME_IN_FORCES = [
    { cod: 1, desc: 'Hoje', webfeeder: 'DAY', showInBillet: true },
    { cod: 3, desc: 'Até cancelar (VAC)', webfeeder: 'GTC', showInBillet: true },
    { cod: 2, desc: 'Até a Data', webfeeder: 'GTD', showInBillet: true },
    { cod: 4, desc: 'Executa/Cancela', webfeeder: 'IOC', showInBillet: true },
    { cod: 5, desc: 'Tudo/Nada', webfeeder: 'FOK', showInBillet: true },
    { cod: 6, desc: 'No Fechamento', webfeeder: 'ATC', showInBillet: true },
    { cod: 7, desc: 'No Leilão', webfeeder: 'GFA', showInBillet: true },
    { cod: 8, desc: 'Até cancelar (VAC)', webfeeder: 'VAC', showInBillet: false },
    { cod: 9, desc: 'Até a Data', webfeeder: 'VAD', showInBillet: false },
    { cod: 10, desc: 'Executa/Cancela', webfeeder: 'EOC', showInBillet: false },
    { cod: 11, desc: 'Tudo/Nada', webfeeder: 'TON', showInBillet: false },
    { cod: 12, desc: 'VAC', webfeeder: 'GTC', showInBillet: false },
    { cod: 13, desc: 'DAY', webfeeder: 'DAY', showInBillet: false },
  ];

  public static ORDER_HISTORY_MARKETS = [
    { cod: 1, desc: 'Bovespa', webfeeder: 'XBSP' },
    { cod: 2, desc: 'BM&F', webfeeder: 'XBMF' },
  ];

  public static CUSTODY_POSITION_TYPE = [
    { cod: 1, desc: 'A Vista' },
    { cod: 2, desc: 'Opção' },
    { cod: 3, desc: 'Termo' },
    { cod: 4, desc: 'BTC' }
  ];

  public static ORDER_HISTORY_DIRECTIONS = [
    { cod: 1, desc: 'Compra', webfeeder: 'BUY' },
    { cod: 2, desc: 'Venda', webfeeder: 'SELL' },
  ];

  public static ORDER_HISTORY_STATUS = [
    { cod: 1, desc: 'Todas', webfeeder: '', geric: '' },
    {
      cod: 2, desc: 'Abertas', webfeeder: 'Abertas', generic: [
        'Nova',
        'Parcialmente Executada',
        'Editada',
        'Cancelamento Pendente',
        'Pendente',
        'Edição Pendente',
        'Suspensa',
        'Aberta'
      ]
    },
    {
      cod: 3, desc: 'Editaveis', webfeeder: 'Editaveis', generic: [
        'Nova',
        'Parcialmente Executada',
        'Aberta editada',
        'Editada',
        'Cancelamento Pendente',
        'Pendente',
        'Edição Pendente',
        'Suspensa',
        'Aberta'
      ]
    },
  ];

  public static ORDER_HISTORY_STATUS_WF = [
    { code: '0', value: 'Nova', alert: 'warn', message: 'Ordem de [SIDE] de [QUOTE] recebida com sucesso. ID: [ID]' },
    { code: '1', value: 'Parcialmente Executada', alert: 'success', message: 'Ordem executada. [SIDE] de  [QUOTE] no preço [PREÇO_EXECUCAO]. QTD.: [QTD_EXECUTADA] de [QTD_TOTAL].  ID: [ID]' },
    { code: '2', value: 'Completamente Executada', alert: 'success', message: 'Ordem executada. [SIDE] de  [QUOTE] no preço [PREÇO_EXECUCAO]. QTD.: [QTD_EXECUTADA] de [QTD_TOTAL].  ID: [ID]' },
    { code: '4', value: 'Cancelada', alert: 'error', message: 'Ordem de [QUOTE] cancelada com sucesso. ID: [ID]' },
    { code: '5', value: 'Editada', alert: 'info', message: 'Ordem de [QUOTE] editada com sucesso. ID: [ID]' },
    { code: '6', value: 'Pendente Cancelar', alert: '', message: '' },
    { code: '8', value: 'Rejeitada', alert: 'error', message: 'Ordem de [SIDE] de [QUOTE] rejeitada.' },
    { code: '9', value: 'Suspensa', alert: '', message: '' },
    { code: 'A', value: 'Pendente Nova', alert: '', message: '' },
    { code: 'C', value: 'Expirada', alert: 'alert', message: 'Ordem de [QUOTE] expirada. ID: [ID]' },
    { code: 'E', value: 'Pendente Editar', alert: '', message: '' },
    { code: 'R', value: 'Recebida', alert: '', message: '' },
  ];

  public static ORDER_SEND_OPEN_EDIT_STATUS = ['0', '5', 'R'];
  public static ORDER_SEND_PENDENT_EDIT_STATUS = ['6', 'A', 'E'];

  public static NEWS_COMPANIES_URL = [
    { cod: 0, name: 'Cedro News', url: './assets/images/assets/logo-cedro.png' },
    { cod: 1, name: 'Agencia Bovespa', url: './assets/images/assets/logo-b3.png' },
    { cod: 2, name: 'Agencia BMF', url: './assets/images/assets/logo-b3.png' },
    { cod: 3, name: 'Investimentos e Notícias', url: './assets/images/assets/logo-invest-news.png' },
  ];

  public static IMG_NOTEBOOK_URL = './assets/images/assets/laptop.png';

  public static PRICE_TYPES = [
    { cod: false, desc: 'Limitado' },
    { cod: true, desc: 'Mercado' }
  ];

  public static CUSTODY_TAB_FILTER = [
    {
      id: 0, value: 'Bovespa', market: 'XBSP', filters: [
        { id: 0, type: 'input-radio', value: 'position-current', desc: 'Posição atual' },
        { id: 1, type: 'input-radio', value: 'position-day', desc: 'Posição do dia' },
        {
          id: 2, type: 'input-radio', value: 'position-history', desc: 'Posição histórica', inputs: [
            { id: 0, type: 'input-date', webfeeder: 'initialDate', value: '', desc: 'Data' }
          ]
        },
        {
          id: 3, type: 'input-radio', value: 'position-summary', desc: 'Resumo', inputs: [
            { id: 0, type: 'input-view-graph', webfeeder: 'asset-class', value: '', desc: 'Classe de Ativos' },
            // TODO: Aguardando serviço ser desenvolvido no OMS e WF
            // { id: 1, type: 'input-view-graph', webfeeder: 'asset-sector', value: '', desc: 'Por setor' },
          ]
        }
      ]
    },
    {
      id: 1, value: 'BM&F', market: 'XBMF', filters: [
        { id: 0, type: 'input-radio', value: 'position-current', desc: 'Posição atual' },
        { id: 1, type: 'input-radio', value: 'position-day', desc: 'Posição do dia' }
      ]
    },
    {
      id: 2, value: 'Proventos', market: '', filters: [
        {
          id: 0, type: 'input-radio', webfeeder: 1, value: 'position-credited', desc: 'Creditados', inputs: [
            // TODO: Aguardando desenvolvimento do filtro no WF
            // { id: 0, type: 'input-complete', webfeeder: '', value: '', desc: 'Ativo' },
            { id: 1, type: 'input-date', webfeeder: 'initialDate', value: '', desc: 'Período - Ínicio' },
            { id: 2, type: 'input-date', webfeeder: 'endDate', value: '', desc: 'Período - Fim' },
          ]
        },
        {
          id: 1, type: 'input-radio', webfeeder: 2, value: 'position-provisioned', desc: 'Provisionados'
        }
      ]
    },
  ];

  public static MODAL_RECONNECT_MSG01 = 'Ops! Não há conexão com a internet.  Verifique sua conexão.';
  public static TEXT_INTERNET_ONLINE = 'AGUARDE... RECONECTANDO AOS SERVIDORES...';
  public static TEXT_INTERNET_OFFLINE = 'SEM CONEXÃO COM A INTERNET...';
  public static TEXT_RECCONECT_SOCKET_ONLINE = 'Aguarde... estamos CONECTANDO aos SERVIDORES de NEGOCIAÇÃO...';

  public static MODAL_RECONNECT_TYPE01 = 'no-network';

  public static MODAL_SIDE_LEFT_BALANCE = 'balance';
  public static MODAL_SIDE_LEFT_HISTORY = 'history';
  public static MODAL_SIDE_LEFT_CUSTODY = 'custody';
  public static MODAL_SIDE_LEFT_GRAPH = 'graph';
  public static MODAL_SIDE_LEFT_NEWS = 'news';
  public static MODAL_SIDE_LEFT_BROKERAGE = 'brokerage';
  public static MODAL_SIDE_LEFT_EXTRACT = 'extract';
  public static MODAL_SIDE_LEFT_DEPOSIT = 'deposit';
  public static MODAL_SIDE_LEFT_ASSESSOR_SEARCH = 'assessorSearchClient';
  public static MODAL_SIDE_LEFT_RANKING = 'ranking';
  public static MODAL_SIDE_LEFT_EDUCATIONAL = 'educational';

  public static LABEL_ERROR_ORDER_DEFAULT = 'ORDENS NÃO ENCONTRADAS PARA OS FILTROS INFORMADOS!';
  public static COOKIE_HOUR_TOKEN_WS = '10';

  public static MSG_NO_DATA_TO_SHOW = 'Não há dados para serem exibidos';
  public static MSG_NO_ORDERS_FOUND = 'Nenhuma ordem encontrada!';
  public static MSG_NO_EXTRACTS_FOUND = 'Nenhum extrato encontrado!';

  public static MSG_SELECT_DATE_BEGIN_FINAL = 'Por favor, selecione a data de início e fim!';
  public static MSG_SELECT_DATE_BEGIN_FINAL_COMPLEMENT = 'Só será possível buscar os dados após informar estes campos.';
  public static MSG_SELECT_DATE = 'Por favor, selecione uma data!';
  public static MSG_SELECT_DATE_COMLEMENT = 'Os dados só serão exibidos após a seleção de uma data.';

  // MSG Status OMS e Difusion
  public static MSG_STATUS_OFFLINE_OMS = 'Atenção! O serviço de NEGOCIAÇÃO está OFFLINE ou INDISPONÍVEL no momento.';
  public static MSG_OFFLINE_NEGOTIATION_01 = 'Conecte aos serviços de NEGOCIAÇÃO para ver o conteúdo.';
  public static MSG_OFFLINE_NEGOTIATION_02 = 'Conecte aos serviços de NEGOCIAÇÃO para negociar.';

  // Messages to feature Login
  public static MSG_LOGIN_MSG001 = 'Todos os campos devem ser preenchidos.';
  public static MSG_LOGIN_MSG002 = 'Usuário ou senha incorretos.';
  public static MSG_LOGIN_MSG003 = 'Ocorreu um erro durante a operação, verifique as informações fornecidas e tente novamente.\n' + 'Caso o problema persista, entre em contato conosco.';
  public static MSG_LOGIN_MSG004 = 'Conta autenticada em outro local ou sessão expirada.';
  public static MSG_LOGIN_MSG005 = 'Este é seu primeiro login, altere sua senha para continuar.';
  public static MSG_LOGIN_MSG006 = 'Sua senha foi expirada, altere sua senha para continuar.';
  public static MSG_LOGIN_MSG007 = 'Caractere inválido.';
  public static MSG_LOGIN_MSG008 = 'Não foi possível alterar a senha, verifique as informações fornecidas e tente novamente.';
  public static MSG_LOGIN_MSG009 = 'Senha expirada.';
  public static MSG_LOGIN_MSG010 = 'Usuário inválido.';
  public static MSG_LOGIN_MSG011 = 'Favor digitar seu usuário e senha para mudar para o simulador.';
  public static MSG_LOGIN_MSG012 = 'Favor digitar seu usuário e senha para carregar as corretoras que você tem permissão.';
  public static MSG_LOGIN_MSG013 = 'Ocorreu um erro durante a operação, tente novamente mais tarde.\n' + 'Caso o problema persista, entre em contato conosco.';
  public static MSG_LOGIN_MSG014 = 'Codigo [BROKER] Inválido.';
  public static MSG_LOGIN_MSG015 = 'Código de acesso invalido.';
  public static MSG_LOGIN_MSG016 = 'Falha ao enviar o Código [BROKER].';
  public static MSG_LOGIN_MSG017 = 'Código [BROKER] enviado com sucesso!';
  public static MSG_LOGIN_MSG018 = 'Um novo código foi enviado [SMS_OR_EMAIL] cadastrado.';
  public static MSG_LOGIN_MSG019 = 'Campos inválidos!';
  public static MSG_LOGIN_MSG020 = 'Usuário desconectado da corretora.';
  public static MSG_LOGIN_MSG021 = 'Habilite o seu simulador em tempo real, disponibilizamos 100 mil reais diários para que você possa treinar para se tornar um expert no mercado de ações.';
  public static MSG_LOGIN_MSG022 = 'Favor escolha uma corretora e informe seu usuário e senha.';

  public static MSG_RECOVER_PASSWORD = 'Sua senha foi redefinida com sucesso.';
  public static MSG_RECOVER_PASSWORD_MULTIBROKER = 'Sua senha foi redefinida com sucesso. Conectando aos serviços de negociação.';
  public static FORGOT_TYPE_01 = 1;
  public static FORGOT_TYPE_02 = 2;
  public static MSG01_FORGOT_TITLE = 'Redefinir senha';
  public static MSG01_FORGOT_CONTENT = 'Digite seu endereço de e-mail abaixo e nós o colocaremos de volta nos trilhos.';
  public static MSG02_FORGOT_TITLE_FALSE = 'Código de redefinição não enviado';
  public static MSG02_FORGOT_TITLE = 'Código de redefinição enviado';
  public static MSG02_FORGOT_CONTENT = `Se houver uma conta vinculada a este endereço de e-mail, enviaremos
   instruções para redefinir sua senha.`;
  public static MSG03_FORGOT_ERROR = 'Nova senha está diferente da confirmação da senha. Tente novamente!';
  public static MSG05_FORGOT_ERROR = 'E-mail Inválido. Por favor, informe o e-mail correto.';
  public static MSG06_FORGOT_ERROR = 'A senha não atende as regras especificadas. Por favor, digite uma nova senha.';
  public static MSG07_FORGOT_ERROR = 'Token inválido ou expirado!';
  public static MSG07_FORGOT_ERROR_SUBTITLE = 'Token de acesso Inválido.';
  public static MSG08_FORGOT_ERROR = 'Erro ao localizar Corretora. Caso o problema persista, entre em contato com o nosso time de atendimento';
  public static MSG08_FORGOT_ERROR_TITLE = 'Ocorreu um erro durante a operação.';
  public static MSG08_FORGOT_ERROR_CONTENT = `Verifique as informações fornecidas e tente novamente.
  Caso o problema persista, entre em contato com o nosso time de atendimento:`;

  // messages to signature
  public static MSG01_FORGOT_SIGNATURE_TITLE = 'Recuperar assinatura eletrônica';
  public static MSG01_FORGOT_SIGNATURE_CONTENT = 'Uma mensagem com uma nova assinatura eletrônica vai ser enviada para e-mail cadastrado..';

  public static MSG01_FORGOT_SIGNATURE_TITLE_ERROR = 'Ocorreu um erro durante a operação.';
  public static MSG01_FORGOT_SIGNATURE_CONTENT_ERROR = 'Verifique as informações fornecidas e tente novamente. Caso o problema persista, '
    + 'entre em contato com o nosso time de atendimento:';
  public static MSG01_FORGOT_SIGNATURE_TITLE_CONFIRM = 'E-mail enviado com sucesso!';
  public static MSG01_FORGOT_SIGNATURE_CONTENT_CONFIRM = 'Um e-mail com link para recuperação de nova assinatura eletrônica foi enviado '
    + 'para seu e-mail! Caso não veja em sua caixa de entrada tente localiza-la em seu lixo eletrônico';
  public static MSG01_SIGNATURE_ERROR = 'Nova Assinatura Eletrônica está diferente da confirmação da Assinatura Eletrônica.'
    + ' Tente novamente!';
  public static MSG02_SIGNATURE_ERROR = 'As assinaturas antiga e nova devem ser diferentes.';
  public static MSG03_SIGNATURE_ERROR = 'A assinatura eletrônica deve conter apenas números.';
  public static MSG04_SIGNATURE_ERROR = 'Email inválido ou incorreto.';

  public static MSG01_REQUEST = 'Aguarde o termino da comunicação com o servidor para efetuar uma nova ação.';

  public static MSG_NEWS_NOT_FOUND = 'No momento ainda não temos notícias do dia...';

  // incremental-input
  public static CURRENCY_BRAZILIAN_SYMBOL = 'R$ ';
  public static CURRENCY_USA_SYMBOL = 'U$ ';
  public static CURRENCY_EUR_SYMBOL = '€ ';
  public static THOUSANDS_SEPARATOR = '.';
  public static DECIMALS_SEPARATOR = ',';
  public static BILLET_TICKSIZE_DEFAULT = 2;

  public static QTD_VALUES_FORMAT_OPTIONS = { prefix: '', thousands: Constants.THOUSANDS_SEPARATOR, decimal: Constants.DECIMALS_SEPARATOR, allowNegative: false, precision: 0, align: 'center' };
  public static PRICE_VALUES_FORMAT_OPTIONS = { prefix: '', thousands: Constants.THOUSANDS_SEPARATOR, decimal: Constants.DECIMALS_SEPARATOR, allowNegative: true, precision: Constants.BILLET_TICKSIZE_DEFAULT, align: 'right' };
  public static PRICE_VALUES_FORMAT_OPTIONS_FUTURES = { prefix: '', thousands: Constants.THOUSANDS_SEPARATOR, decimal: Constants.DECIMALS_SEPARATOR, allowNegative: false, precision: 0, align: 'right' };

  // Messages and others informations to the feature Manage Workspace
  public static WORKSPACE_TYPE = WORKSPACE_TYPE;
  public static NUM_MAX_WORKSPACES = 4;
  public static NUM_MIN_WORKSPACES = 1;
  public static NUM_MAX_WORKSPACE_CARDS = 30; // especificado 20
  public static NUM_MIN_WORKSPACE_CARDS = 1;
  public static WORKSPACE_MSG001 = 'Deve existir pelo menos uma área de trabalho ou não estar usando uma área de trabalho offline.';
  public static WORKSPACE_MSG002 = 'Já existe um workspace com esse nome, por favor escolha um nome diferente.';
  public static WORKSPACE_MSG003 = 'Tem certeza que deseja remover a área de trabalho?';
  public static WORKSPACE_MSG004 = 'Tem certeza que deseja remover o componente da área de trabalho?';
  public static WORKSPACE_MSG005 = 'É preciso selecionar um ativo.';
  public static WORKSPACE_MSG006 = 'É preciso selecionar pelo menos um ativo ou uma planilha pré-definida.';
  public static WORKSPACE_MSG007 = 'O ativo selecionado não é um ativo válido.';
  public static WORKSPACE_MSG008 = 'Tem certeza que deseja salvar todas as áreas de trabalho criadas?';
  public static WORKSPACE_MSG009 = 'Usuário desconectado por inatividade.';
  public static WORKSPACE_MSG010 = 'Tentando estabelecer conexão...';
  public static WORKSPACE_MSG011 = `Limite máximo de componentes atingido para a área de trabalho atual,
  remova algum componente ou utilize outra área de trabalho.`;
  public static WORKSPACE_MSG012 = `Limite máximo de planilhas de cotação atingido para a área de trabalho atual,
  remova alguma planilha ou utilize outra área de trabalho.`;
  public static WORKSPACE_MSG013 = 'Nome inválido';
  public static WORKSPACE_MSG014 = 'Já existe esse componente com o ativo selecionado no workspace atual.';
  public static WORKSPACE_MSG015 = 'O ativo selecionado já está em execução. Por favor, selecione outro ativo.';
  public static WORKSPACE_MSG016 = 'Tem certeza que deseja voltar para sua área de trabalho?';
  public static WORKSPACE_MSG017 = 'O ativo selecionado já existe na planilha.';
  public static WORKSPACE_MSG018 = 'Não há dados para serem exibidos';
  public static WORKSPACE_MSG019 = 'É preciso informar pelo menos um caractere.';
  public static WORKSPACE_MSG020 = 'Mercado do ativo não encontrado.';
  public static WORKSPACE_MSG021 = 'Conta não encontrada ou inválida. Tente novamente mais tarde.';
  public static WORKSPACE_MSG022 = 'É preciso selecionar pelo menos uma área de trabalho ou personalizar uma.';
  public static WORKSPACE_MSG023 = 'Você deve aceitar o TERMO DE CIÊNCIA antes de enviar a ordem.';
  public static WORKSPACE_MSG024 = `Limite máximo de XXX atingido para a área de trabalho.`;
  public static WORKSPACE_MSG025 = 'É necessário ter pelo menos um ativo selecionado para que possa expandir';
  public static WORKSPACE_MSG026 = 'Falha ao excluir workspace, por favor tente novamente, caso o problema persista entre em contato conosco.';
  public static WORKSPACE_MSG027 = 'Falha ao renomear workspace, por favor tente novamente, caso o problema persista entre em contato conosco.';
  public static WORKSPACE_MSG028 = 'Falha ao carregar workspace, por favor tente novamente, caso o problema persista entre em contato conosco.';
  public static WORKSPACE_MSG029 = 'Não é possivel adicionar ativo em uma Planilha Pré Definida';
  public static WORKSPACE_MSG030 = 'O ativo {{quote}} foi removido do {{card}} por estar inválido ou vencido, selecione outro.';
  public static WORKSPACE_MSG031 = 'Você deve aceitar os TERMOS DE USO antes de acessar o Home Broker.';
  public static WORKSPACE_MSG032 = 'Para navegar no Home Broker você deve aceitar os TERMOS DE USO. Tem certeza que deseja sair?';
  public static WORKSPACE_MSG033 = 'Termos de uso';
  public static WORKSPACE_MSG034 = 'Para continuar acessando o Home Broker, precisamos que LEIA e ACEITE os termos abaixo:';
  public static WORKSPACE_MSG035 = 'Li, estou de acordo e quero continuar.';
  public static WORKSPACE_MSG036 = 'Termo de Adesão e Ciência de Risco';
  public static WORKSPACE_MSG037 = 'Se quiser continuar com este investimento, você precisa ler e aceitar o termo abaixo.';
  public static WORKSPACE_MSG038 = 'Não foi possível adicionar a ferramenta no workspace atual';
  public static WORKSPACE_MSG039 = 'Conta do perfil alterada com sucesso.';
  public static WORKSPACE_MSG040 = 'Ação não permitida em uma Planilha Pré Definida.';
  public static WORKSPACE_MSG041 = 'Permitido adicionar apenas [QTD] [COMP] por workspace.';

  public static WKS_TITLE_PLACEHOLDER = 'CRIE UMA ÁREA DE TRABALHO';
  public static WKS_NEW_COMPONENT = 'Tem certeza que deseja adicionar o componente a área de trabalho?';
  public static WKS_WORKSPACE_WORKSHEET = `Não é possível adicionar mais colunas na planilha, remova alguma
   coluna para que seja possível adicionar outra.`;
  public static WORKSHEET_MAX_ASSETS_MSG = `Não é possível adicionar mais ativos na planilha,
   remova algum ativo para que seja possível adicionar outro.`;
  public static WKS_WORKSPACE_CONF_MODAL_INFO1 = `Investidor, vamos começar? Selecione uma tela já
   definida com ajuda de nossos traders ou crie e`;
  public static WKS_WORKSPACE_CONF_MODAL_INFO2 = ` personalize sua própria área de trabalho. Defina suas estratégias, e bons negócios!`;

  public static WORKSHEET_MSG001 = 'Ocorreu um erro ao deletar a Planilha de Cotação.';
  public static WORKSHEET_MSG002 = 'Planilha de Cotação não encontrada. Tente novamente mais tarde.';
  public static WORKSHEET_MSG003 = 'Tem certeza que deseja remover a Planilha de Cotação: ';
  public static WORKSHEET_MSG004 = 'Ocorreu um erro na solicitação de alteração da Planilha de Cotação.';
  public static WORKSHEET_MSG005 = 'Planilha de Cotação alterada com sucesso.';
  public static WORKSHEET_MSG006 = 'Ocorreu um erro no carregamento da(s) lista(s) de Planilha de Cotação.';
  public static WORKSHEET_MSG007 = 'Ocorreu um erro na criação da nova Planilha de Cotação.';
  public static WORKSHEET_MSG008 = 'Deve existir pelo menos uma Planilha de Cotação.';
  public static WORKSHEET_MSG009 = 'Já existe uma Planilha de Cotação com esse nome, por favor escolha um nome diferente.';
  public static WORKSHEET_MSG010 = 'Planilha de Cotação removida com sucesso.';

  // Messages and others informations to the feature Manage Billet
  public static BILLET_ORDER_MSG001 = 'O ativo selecionado não é um ativo válido.';
  public static BILLET_ORDER_MSG002 = 'A quantidade deve ser maior que zero.';
  public static BILLET_ORDER_MSG005 = 'Todos os campos obrigatórios devem ser preenchidos.';
  public static BILLET_ORDER_MSG006 = 'Preço zerado ou inválido.';
  public static BILLET_ORDER_GAIN = 'STOP GAIN';
  public static BILLET_ORDER_LOSS = 'STOP LOSS';
  public static BILLET_ORDER_1_TRIGGER_BUY = 'Preço de disparo de loss deve ser maior ou igual que o preço do último negócio.';
  public static BILLET_ORDER_1_TRIGGER_SELL = 'Preço de disparo de loss deve ser menor ou igual que o preço do último negócio.';
  public static BILLET_ORDER_2_TRIGGER_BUY = `Preço de disparo de gain deve ser menor ou igual que o preço do último negócio.`;
  public static BILLET_ORDER_2_TRIGGER_SELL = `Preço de disparo de gain deve ser maior ou igual que o preço do último negócio.`;
  public static BILLET_ORDER_1_LIMIT_BUY = 'Preço limite de loss deve ser maior ou igual ao preço de disparo de loss.';
  public static BILLET_ORDER_1_LIMIT_SELL = 'Preço limite de loss deve ser menor ou igual ao preço de disparo de loss.';
  public static BILLET_ORDER_2_LIMIT_BUY = 'Preço limite de gain deve ser maior ou igual ao preço de disparo de gain.';
  public static BILLET_ORDER_2_LIMIT_SELL = 'Preço limite de gain deve ser menor ou igual ao preço de disparo de gain.';
  public static BILLET_ORDER_EMPTY_SIGNATURE = 'Por favor informe sua Assinatura Eletrônica.';
  public static BILLET_ORDER_VALID_SIGNATURE = 'Assinatura Eletrônica inválida!';

  public static BILLET_ORDER_SEND_01 = 'Enviando ordem...';
  public static BILLET_ORDER_SEND_02 = 'Para acompanhar sua(s) ordem(ns) clique aqui';
  public static BILLET_ORDER_SEND_03 = 'Ocorreu um erro na solicitação de envio da ordem. Tente novamente mais tarde.';
  public static BILLET_ORDER_SEND_04 = 'O PERFIL de SUITABILITY deve ser preenchido para enviar ordem.';
  public static BILLET_ORDER_SEND_05 = 'Ocorreu um erro na validação do Suitability! Tente novamente mais tarde.';
  public static BILLET_ORDER_SEND_06 = 'Código de segurança deve ser informado.';
  public static BILLET_ORDER_SEND_07 = 'Código de segurança inválido. Informe novamente o Código de segurança!';
  public static BILLET_ORDER_SEND_08 = 'Operação não permitida. Favor entrar em contato com o cliente, solicitando ao mesmo a assinatura do Termo de Desenquadramento.';
  public static BILLET_ORDER_SEND_09 = 'Ocorreu um erro na solicitação de cancelamento da ordem. Tente novamente mais tarde.';
  public static BILLET_ORDER_SEND_10 = 'Enviando cancelamento de ordem...';
  public static BILLET_ORDER_SEND_11 = 'Valor deve ser múltiplo do lote default.';
  public static BILLET_ORDER_SEND_12 = 'Enviando edição de ordem...';
  public static BILLET_ORDER_SEND_13 = 'Ocorreu um erro na solicitação de edição da ordem. Tente novamente mais tarde.';
  public static BILLET_ORDER_SEND_14 = 'Requisição de zeragem de posição enviada com sucesso.';

  public static ORDER_HISTORY_MSG001 = 'A quantidade deve ser maior que zero.';
  public static ORDER_HISTORY_MSG002 = 'Tem certeza que deseja cancelar a ordem?';
  public static ORDER_HISTORY_MSG003 = 'Tem certeza que deseja atualizar a ordem?';
  public static ORDER_HISTORY_MSG015 = 'Tem certeza que deseja replicar a ordem?';
  public static ORDER_HISTORY_MSG004 = 'Termo de aceite enviado com sucesso!';
  public static ORDER_HISTORY_MSG005 = 'Ocorreu um erro ao enviar o termo de aceite! Tente novamente mais tarde.';
  public static ORDER_HISTORY_MSG006 = 'Tem certeza que deseja atualizar todas as ordens?';
  public static ORDER_HISTORY_MSG013 = 'Ao atualizar você estará automaticamente atualizando todas as ordens deste ativo em aberto com este preço.';
  public static ORDER_HISTORY_MSG007 = 'Deseja cancelar todas as ordem?';
  public static ORDER_HISTORY_MSG008 = 'Ao cancelar você estará automaticamente cancelando todas as ordens deste ativo em aberto.';
  public static ORDER_HISTORY_MSG009 = 'Não há ordens de [QUOTE] em ABERTO para cancelar.';
  public static ORDER_HISTORY_MSG014 = 'Não há ordens de [QUOTE] em ABERTO para editar.';
  public static ORDER_HISTORY_MSG010 = 'Cancelar todas as ordens deste ativo.';
  public static ORDER_HISTORY_MSG011 = 'Deseja zerar suas posições?';
  public static ORDER_HISTORY_MSG012 = 'Ao concordar você estará automaticamente zerando todas as posições e cancelando todas as ordens deste ativo em aberto.';

  public static ORDER_CLEAR_MSG013 = 'Você não tem posição de [QUOTE]. Não é possível ZERAR.';

  public static BILLET_QUICK_QTD_ZERO = 'O ativo selecionado não possui posição no momento! A ação de ZERAR não pode ser realizada.';


  public static MARKET_OPEN_CLOSED_MSG001 = 'Olá, no momento o mercado está fechado.';

  // Please, don't remove the 'Enters' of this messages, they are needed to tell the tooltips to break the lines
  public static BILLET_ORDER_STOP_BUY_LOSS = `• Preço de disparo deve ser maior que o preço do último negócio.

• Preço de limite deve ser maior ou igual ao preço de disparo.`;
  public static BILLET_ORDER_STOP_BUY_GAIN = `• Preço de disparo deve ser menor que o preço do último negócio.

• Preço limite deve ser maior ou igual ao preço de disparo.`;
  public static BILLET_ORDER_OCO_STOP_BUY_GAIN = '• Preço deve ser menor que a cotação atual.';
  public static BILLET_ORDER_STOP_SELL_LOSS = `• Preço de disparo deve ser menor que o preço do último negócio.

• Preço limite deve ser menor ou igual ao preço de disparo.`;
  public static BILLET_ORDER_STOP_SELL_GAIN = `• Preço de disparo deve ser maior que o preço do último negócio.

• Preço limite deve ser menor ou igual ao preço de disparo.`;
  public static BILLET_ORDER_OCO_STOP_SELL_GAIN = '• Preço deve ser maior que a cotação atual.';
  public static BILLET_ORDER_STOP_BUY_SIM = `• Preço de disparo de loss deve ser maior que o preço do último negócio.

• Preço limite de loss deve ser maior ou igual ao preço de disparo de loss.

• Preço de disparo de gain deve ser menor que o preço do último negócio.

• Preço limite de gain deve ser maior ou igual ao preço de disparo de gain.`;
  public static BILLET_ORDER_STOP_SELL_SIM = `• Preço de disparo de loss deve ser menor que o preço do último negócio.

• Preço limite de loss deve ser menor ou igual ao preço de disparo de loss.

• Preço de disparo de gain deve ser maior que o preço do último negócio.

• Preço limite de gain deve ser menor ou igual ao preço de disparo de gain.`;

  // Messages and others informations for the Billet situations

  // Messages and other informations to the Order history
  public static DATE_MSG001 = 'A data início deve ser menor ou igual a data final.';
  public static DATE_MSG002 = 'A data final deve ser menor ou igual a data atual.';
  public static DATE_MSG003 = 'Não é possível filtrar com apenas uma das datas preenchidas.';
  public static DATE_MSG004 = 'Notícia não encontrada.';
  public static DATE_MSG005 = 'Não é possível filtrar com intervalo maior que {{range}} dias.';

  public static BROKERAGE_MSG_001 = 'Nota(s) de corretagem não encontrada.';

  // Gridster items default positions configuration
  // Consult \src\app\..\workspace-new\gridsteroptions.txt
  public static GRID_MARGIN = 8;
  public static GRID_OUTER_MARGIN = true;
  public static GRID_OUTER_MARGIN_SIZE = 16;
  public static GRID_MAX_COLS = 6;
  public static GRID_MIN_COLS = 6;
  public static GRID_MAX_ROWS = 25;
  public static GRID_MIN_ROWS = 25;
  public static GRID_SET_SIZE = true;
  public static GRID_PUSH_ITEMS = false;
  public static GRID_DRAGGABLE = true;
  public static GRID_COL_WIDTH = 304;
  public static GRID_ROW_HEIGHT = 205;
  public static GRID_SWAP = false;
  public static GRID_SWAP_DRAGGING = false;
  public static GRID_WINDOW_RESIZE = true;
  public static GRID_PUSH_ON_DRAG = false;
  public static GRID_RESIZABLE = true;
  public static GRID_MAX_ITEM_AREA = 10;
  public static GRID_COMPACT = 'compactUp&Left';

  public static MAX_WKS_CONF = 2;

  public static SM_WINDOW_RES2 = 1438;
  public static SM_WINDOW_RES = 1566;
  public static SMM_WINDOW_RES2 = 1718;
  public static SMM_WINDOW_RES = 1842;
  public static MD_WINDOW_RES = 2012;
  // public static MD_WINDOW_RES2 = 1921;
  // public static MDD_WINDOW_RES = 2128;
  // public static LG_WINDOW_RES = 2145;

  // Variables to pass on PanelClass
  public static NORMAL_MODAL = 'mat-modal-normal';
  public static ELETRONIC_SIGNATURE_MODAL = 'mat-modal-eletronic-signature';
  public static TERM_OPERATOR_MODAL = 'mat-modal-term-operator';
  public static FULL_BOTTOMSHEET = 'full-width-bottomsheet';
  public static FULL_MODAL = 'mat-modal-fullheight';
  public static CENTER_MODAL = 'mat-modal-centered';

  public static ESC_KEY_CODE = 27;

  public static WF_SERVICE_ERROR_CODE = 100;
  public static WF_SERVICE_LOGIN_ERROR_CODE = 111;

  public static MSG_MIN_RESOLUTION = 'A resolução minima para funcionamento do Fast Trade Web Desktop é de 1280x768, para acessar '
    + 'o sistema em resoluções menores faça o download da nossa aplicação móvel na Google Play ou Apple Store.';
  public static MIN_RESOLUTION = 1280;

  // Config variables to Simple Notifications
  public static SIMPLE_NOTIFICATIONS_TIMEOUT = 3000;
  public static SIMPLE_NOTIFICATIONS_PROGRESS = true;

  public static RECONNECT_ANIMATION_URL = 'assets/images/animations/reconnect.json';
  public static RECONNECTED_ANIMATION_URL = 'assets/images/animations/reconnected.json';
  public static LOADING_ANIMATION_URL = 'assets/images/animations/loading.json';
  public static SENDING_EMAIL_ANIMATION_URL = 'assets/images/animations/sending-mail.json';

  public static QUOTE_STATUS_MAP = [
    { id: 0, text: 'Negociação' },
    { id: 1, text: 'Congelado' },
    { id: 2, text: 'Suspenso' },
    { id: 3, text: 'Leilão' },
    { id: 4, text: 'Inibido' }
  ];

  public static statusClassList = {
    '0': 'circle-green-icon',
    '1': 'circle-yellow-icon',
    '2': 'circle-red-icon',
    '3': 'circle-yellow-icon',
    '4': 'circle-green-icon'
  };

  public static VALUE_NUMBER_NULL = -1;
  public static RESOLUTION_MINIMUM_HEIGHT = 768;
  public static RESOLUTION_MINIMUM_WIDTH = 1024;

  public static WINDOW_NAME_SELECTOR_INPUT = 'selector_input';
  public static WINDOW_NAME_SELECTOR_SELECT = 'selector_select';
  public static WINDOW_NAME_EDIT_ORDER = 'edit_order';
  public static WINDOW_NAME_QUICK_SEARCH_AUTO_COMPLETE = 'quick_search_auto_complete';
  public static WINDOW_NAME_SIMULATANEOS_STOP_ORDER = 'simulataneos_stop_order';
  public static WINDOW_NAME_STOP_GAIN_BUY_ORDER = 'stop_gain_buy_order';

  public static SIGNATURE_ELETRONIC = 'SIGNATURE';
  public static SIGNATURE_ELETRONIC_TYPE = 'SIGNATURE_ELETRONIC_TYPE';

  public static WINDOW_NAME_MAIN_WINDOW = 'main-window';
  public static WINDOW_NAME_ASSET_SUMMARY = 'asset-summary';
  public static WINDOW_NAME_BOOK = 'book';
  public static WINDOW_NAME_WORK_SHEET = 'worksheet';
  public static WINDOW_NAME_NEWS_SEARCH = 'news-search';
  public static WINDOW_NAME_MARKET_HIGHLIGHTS = 'market';
  public static WINDOW_NAME_QUOTE_BOX = 'quoted-box';
  public static WINDOW_NAME_TIMES_TRADES = 'times-trades';
  public static WINDOW_NAME_QUOTE_CHART = 'quote-chart';
  public static WINDOW_NAME_VOLUME_AT_PRICE = 'volume-at-price';
  public static WINDOW_NAME_BILLET_QUICK = 'billet-quick';
  public static WINDOW_NAME_BILLET_ROOT = 'billet-root';
  public static WINDOW_NAME_BILLET_WKS = 'billet-wks';
  public static WINDOW_NAME_BILLET_FLOAT = 'billet-float';
  public static WINDOW_NAME_NEWS_WKS = 'news-wks';
  public static WINDOW_NAME_HIGH_LOW_DAY = 'high-low-day';
  public static WINDOW_NAME_POSITION_DAY = 'position-day';
  public static WINDOW_NAME_POSITION_BALANCE = 'position-balance-wks';
  public static WINDOW_NAME_ORDER_WKS = 'order-wks';
  public static WINDOW_NAME_HISTORY_ORDER = 'history-order';
  public static WINDOW_NAME_SYSTEM_HOME = 'sytem_home';
  public static WINDOW_NAME_SIDE_BAR = 'side_bar';
  public static WINDOW_NAME_TRADE_CHART = 'trade_chart';
  public static WINDOW_NAME_ORDER_CHART = 'order_chart';

  public static WINDOW_NAME_MODAL_CHART = 'modal_trading_view';
  public static WINDOW_NAME_MODAL_CUSTODY = 'modal_custody';
  public static WINDOW_NAME_MODAL_ORDER = 'modal_order';
  public static WINDOW_NAME_MODAL_DEPOSIT = 'modal_deposity';
  public static WINDOW_NAME_MODAL_PATRIMONY = 'modal_patrimony';
  public static WINDOW_NAME_MODAL_BROKERAGE = 'modal_brokerage';
  public static WINDOW_NAME_MODAL_FINANCIAL_STATEMENT = 'modal_financial_statement';
  public static WINDOW_NAME_MODAL_NEWS = 'modal_news';

  public static TITLE_CARD_BOOK = 'LIVRO DE OFERTAS';
  public static TITLE_CARD_WORKSHEET = 'PLANILHA DE COTAÇÃO';
  public static TITLE_CARD_VOLUME_AT_PRICE = 'VOLUME POR PREÇO';
  public static TITLE_CARD_TIMES_TRADES = 'NEGÓCIOS REALIZADOS';
  public static TITLE_CARD_ASSET_SUMMARY = 'RESUMO DO ATIVO';
  public static TITLE_CARD_QUOTE_CHART = 'GRÁFICOS';
  public static TITLE_CARD_BILLET_ROOT = 'BOLETAS';
  public static TITLE_CARD_BILLET_QUICK = 'BOLETA RÁPIDA';
  public static TITLE_CARD_BILLET_WKS = 'BOLETA SIMPLES';
  public static TITLE_CARD_BILLET_DOM = 'BOLETA DOM';
  public static TITLE_CARD_NEWS_WKS = 'NOTÍCIAS';
  public static TITLE_CARD_HIGH_LOW_DAY = 'MAIORES DO DIA';
  public static TITLE_CARD_POSITION_DAY = 'POSIÇÃO DO DIA';
  public static TITLE_CARD_POSITION_BALANCE = 'POSIÇÃO FINANCEIRA';
  public static TITLE_CARD_ORDER_WKS = 'ORDENS DO DIA';
  public static TITLE_COMPONENT_HEADER = 'HEADER BAR';

  public static TITLE_CARD_MODAL_CUSTODY = 'CONSULTA DE CUSTÓDIA';
  public static TITLE_CARD_MODAL_ORDER = 'CONSULTA DE ORDENS';
  public static TITLE_CARD_MODAL_DEPOSIT = 'RETIRAR/INFORMAR DEPÓSITO';
  public static TITLE_CARD_MODAL_BROKERAGE = 'NOTA DE CORRETAGEM';
  public static TITLE_CARD_MODAL_PATRIMONY = 'PATRIMÔNIO';
  public static TITLE_CARD_MODAL_FINANCIAL_STATEMENT = 'EXTRATO FINANCEIRO';
  public static TITLE_CARD_MODAL_NEWS = 'NOTÍCIAS';
  public static TITLE_CARD_SUPPORT_CHANNELS = 'Canais de Atendimento';

  public static TITLE_CARD_MANUAL = 'MANUAL DO USUÁRIO';
  public static QTD_MAX_ASSETS_WORKSHEET = 100;
  public static QTD_MAX_WORKSHEET = 25;
  public static QTD_MAX_BILLET_QUICK = 25;
  public static QTD_MAX_BILLET_WKS = 25;
  public static QTD_MAX_BILLET_ROOT = 25;
  public static QTD_MAX_NEWS_WKS = 25;
  public static QTD_MAX_HIGH_LOW_DAY = 25;
  public static QTD_MAX_POSITION_DAY = 25;
  public static QTD_MAX_POSITION_BALANCE = 25;
  public static QTD_MAX_ORDER_WKS = 25;
  public static QTD_MAX_CHART = 25;
  public static QTD_MAX_BOOK = 25;
  public static QTD_MAX_VOLUME_AT_PRICE = 25;
  public static QTD_MAX_ASSET_SUMMARY = 25;
  public static QTD_MAX_TIMES_TRADE = 25;

  public static TOOLTIP_ENGINE = 'Configurações';
  public static TOOLTIP_CENTER_STAIRCASE_ON = 'Centralizar Preço';
  public static TOOLTIP_CENTER_STAIRCASE_OFF = 'Descentralizar Preço';
  public static TOOLTIP_REMOVE_WKS_TOOL = 'Remover Ferramenta';
  public static TOOLTIP_ADD_WKS_TOOL = 'Adicionar Ferramenta';
  public static TOOLTIP_CANCEL = 'Cancelar';

  public static MULTI_BROKER_TYPES = [
    { type: 1, description: 'Sem Corretora', id: 'no-broker', tooltip: '' },
    { type: 2, description: 'Simulador', id: 'simulator', tooltip: Constants.MSG_LOGIN_MSG011 },
    { type: 3, description: 'Corretora', id: 'broker', tooltip: Constants.MSG_LOGIN_MSG012 }
  ];

  public static MULTI_BROKER_TYPES_RADIO = [
    { type: 1, description: 'Produção', id: 'broker', tooltip: Constants.MSG_LOGIN_MSG022 },
    { type: 0, description: 'Simulador', id: 'simulator', tooltip: Constants.MSG_LOGIN_MSG021 },
  ];

  public static BILLET_TYPE_BILLET = [
    { id: 0, name: 'SIMPLES', showBoxPosition: false, subscribeScktPosition: true, showBookAggregate: true, subscribeScktDailyOrder: false, },
    { id: 1, name: 'RÁPIDA', showBoxPosition: true, subscribeScktPosition: true, showBookAggregate: true, subscribeScktDailyOrder: false, },
    { id: 2, name: 'DOM', showBoxPosition: true, subscribeScktPosition: true, showBookAggregate: true, subscribeScktDailyOrder: true, },
  ];

  public static BILLET_WKS_SIMPLE_CONFIG = [
    { id: 0, inputName: 'type', desc: 'Precificação', col: 12, class: 'p-0', active: false },
    { id: 1, inputName: 'orderStrategy', desc: 'Estratégia', col: 6, class: 'p-right', active: true },
    { id: 2, inputName: 'timeInForces', desc: 'Duração', col: 6, class: 'p-left', active: true },
    { id: 3, inputName: 'validityOrder', desc: 'Data do vencimento', col: 6, class: 'p-right', active: true },
    { id: 4, inputName: 'qtd', desc: 'Quantidade', col: 6, class: 'p-left', active: true },
    { id: 5, inputName: 'price', desc: 'Preço', col: 6, class: 'p-right', active: true },
    { id: 6, inputName: 'loss-toggle', desc: 'STOP LOSS', col: 12, class: 'p-0', active: false, showToggle: false },
    { id: 7, inputName: 'stoptrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-loss-content', active: false },
    { id: 8, inputName: 'stoplimit', desc: 'Preço de limite', col: 6, class: 'p-right stop-loss-content', active: false },
    { id: 9, inputName: 'gain-toggle', desc: 'STOP GAIN', col: 12, class: 'p-0 info-row', active: false, showToggle: false },
    { id: 10, inputName: 'targettrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-gain-content', active: false },
    { id: 11, inputName: 'targetlimit', desc: 'Preço', col: 6, class: 'p-right stop-gain-content', active: false },
    {
      id: 12, inputName: 'currentQuantity', desc: 'Posição Atual', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. em custódia:', col: 9, class: 'title' },
        { id: 2, inputName: 'currentQuantity', desc: '', col: 3, class: 'value right' },
      ]
    },
    {
      id: 13, inputName: 'positionReleased', desc: 'Posição Venda', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. liberada para venda:', col: 9, class: 'title' },
        { id: 2, inputName: 'quantityReleased', desc: '', col: 3, class: 'value right' }
      ]
    },
    { id: 14, inputName: 'checkMarket', desc: 'Tipo de ordem', col: 6, class: 'p-left', active: true },
    { id: 15, inputName: 'gain-toggle', desc: 'Opções Avançadas', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 16, inputName: 'maxfloor', desc: 'Quantidade aparente', col: 6, class: 'p-left', active: true },
    { id: 17, inputName: 'minqtd', desc: 'Quantidade mínima', col: 6, class: 'p-right', active: true },
    { id: 18, inputName: 'orderTag', desc: 'Observação', col: 12, class: 'p-0', active: true },
    {
      id: 19, inputName: 'balanceProjOnline', desc: 'Saldo Projetado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Saldo Projetado:', col: 6, class: 'title' },
        { id: 2, inputName: 'balanceProjOnline', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 20, inputName: 'uniqueLimit', desc: 'Limite Operacional', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Limite Operacional:', col: 6, class: 'title' },
        { id: 2, inputName: 'uniqueLimit', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 21, inputName: 'lastTrade', desc: 'Preço a mercado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Preço a mercado:', col: 6, class: 'title' },
        { id: 2, inputName: 'lastTrade', desc: '', col: 6, class: 'value right' },
      ]
    }
  ];

  public static BILLET_WKS_STOP_CONFIG = [
    { id: 0, inputName: 'type', desc: 'Precificação', col: 12, class: 'p-0', active: false },
    { id: 1, inputName: 'orderStrategy', desc: 'Estratégia', col: 6, class: 'p-right', active: true },
    { id: 2, inputName: 'timeInForces', desc: 'Duração', col: 6, class: 'p-left', active: true },
    { id: 3, inputName: 'validityOrder', desc: 'Data do vencimento', col: 6, class: 'p-right', active: true },
    { id: 4, inputName: 'qtd', desc: 'Quantidade', col: 12, class: 'p-0', active: true },
    { id: 5, inputName: 'price', desc: 'Preço', col: 6, class: 'p-right', active: false },
    { id: 6, inputName: 'loss-toggle', desc: 'Stop Loss', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 7, inputName: 'stoptrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-loss-content', active: true },
    { id: 8, inputName: 'stoplimit', desc: 'Preço de limite', col: 6, class: 'p-right stop-loss-content', active: true },
    { id: 9, inputName: 'gain-toggle', desc: 'Stop Gain', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 10, inputName: 'targettrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-gain-content', active: true },
    { id: 11, inputName: 'targetlimit', desc: 'Preço', col: 6, class: 'p-right stop-gain-content', active: true },
    {
      id: 12, inputName: 'currentQuantity', desc: 'Posição Atual', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. em custódia:', col: 9, class: 'title' },
        { id: 2, inputName: 'currentQuantity', desc: '', col: 3, class: 'value right' }
      ]
    },
    {
      id: 13, inputName: 'positionReleased', desc: 'Posição Venda', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. liberada para venda:', col: 9, class: 'title' },
        { id: 2, inputName: 'quantityReleased', desc: '', col: 3, class: 'value right' }
      ]
    },
    { id: 14, inputName: 'checkMarket', desc: 'Tipo de ordem', col: 6, class: 'p-left', active: true },
    { id: 15, inputName: 'gain-toggle', desc: 'Opções Avançadas', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 16, inputName: 'maxfloor', desc: 'Quantidade aparente', col: 6, class: 'p-left', active: true },
    { id: 17, inputName: 'minqtd', desc: 'Quantidade mínima', col: 6, class: 'p-right', active: true },
    { id: 18, inputName: 'orderTag', desc: 'Observação', col: 12, class: 'p-0', active: true },
    {
      id: 19, inputName: 'balanceProjOnline', desc: 'Saldo Projetado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Saldo Projetado:', col: 6, class: 'title' },
        { id: 2, inputName: 'balanceProjOnline', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 20, inputName: 'uniqueLimit', desc: 'Limite Operacional', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Limite Operacional:', col: 6, class: 'title' },
        { id: 2, inputName: 'uniqueLimit', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 21, inputName: 'lastTrade', desc: 'Preço a mercado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Preço a mercado:', col: 6, class: 'title' },
        { id: 2, inputName: 'lastTrade', desc: '', col: 6, class: 'value right' },
      ]
    }
  ];

  public static BILLET_WKS_STOP_LOSS_CONFIG = [
    { id: 0, inputName: 'type', desc: 'Precificação', col: 12, class: 'p-0', active: false },
    { id: 1, inputName: 'orderStrategy', desc: 'Estratégia', col: 6, class: 'p-right', active: true },
    { id: 2, inputName: 'timeInForces', desc: 'Duração', col: 6, class: 'p-left', active: true },
    { id: 3, inputName: 'validityOrder', desc: 'Data do vencimento', col: 6, class: 'p-right', active: true },
    { id: 4, inputName: 'qtd', desc: 'Quantidade', col: 12, class: 'p-0', active: true },
    { id: 5, inputName: 'price', desc: 'Preço', col: 6, class: 'p-right', active: false },
    { id: 6, inputName: 'loss-toggle', desc: 'Stop Loss', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 7, inputName: 'stoptrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-loss-content', active: true },
    { id: 8, inputName: 'stoplimit', desc: 'Preço de limite', col: 6, class: 'p-right stop-loss-content', active: true },
    { id: 9, inputName: 'gain-toggle', desc: 'Stop Gain', col: 12, class: 'info-row advance m-btn-5', active: false, showToggle: false },
    { id: 10, inputName: 'targettrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-gain-content', active: false },
    { id: 11, inputName: 'targetlimit', desc: 'Preço', col: 6, class: 'p-right stop-gain-content', active: false },
    {
      id: 12, inputName: 'currentQuantity', desc: 'Posição Atual', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. em custódia:', col: 9, class: 'title' },
        { id: 2, inputName: 'currentQuantity', desc: '', col: 3, class: 'value right' }
      ]
    },
    {
      id: 13, inputName: 'positionReleased', desc: 'Posição Venda', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. liberada para venda:', col: 9, class: 'title' },
        { id: 2, inputName: 'quantityReleased', desc: '', col: 3, class: 'value right' }
      ]
    },
    { id: 14, inputName: 'checkMarket', desc: 'Tipo de ordem', col: 6, class: 'p-left', active: true },
    { id: 15, inputName: 'gain-toggle', desc: 'Opções Avançadas', col: 12, class: 'info-row advance m-btn-5', active: true, showToggle: true },
    { id: 16, inputName: 'maxfloor', desc: 'Quantidade aparente', col: 6, class: 'p-left', active: true },
    { id: 17, inputName: 'minqtd', desc: 'Quantidade mínima', col: 6, class: 'p-right', active: true },
    { id: 18, inputName: 'orderTag', desc: 'Observação', col: 12, class: 'p-0', active: true },
    {
      id: 19, inputName: 'balanceProjOnline', desc: 'Saldo Projetado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Saldo Projetado:', col: 6, class: 'title' },
        { id: 2, inputName: 'balanceProjOnline', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 20, inputName: 'uniqueLimit', desc: 'Limite Operacional', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Limite Operacional:', col: 6, class: 'title' },
        { id: 2, inputName: 'uniqueLimit', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 21, inputName: 'lastTrade', desc: 'Preço a mercado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Preço a mercado:', col: 6, class: 'title' },
        { id: 2, inputName: 'lastTrade', desc: '', col: 6, class: 'value right' },
      ]
    }
  ];

  public static BILLET_WKS_STOP_OCO_CONFIG = [
    { id: 0, inputName: 'type', desc: 'Precificação', col: 6, class: 'p-left', active: false },
    { id: 1, inputName: 'orderStrategy', desc: 'Operação', col: 12, class: 'p-0', active: true },
    { id: 2, inputName: 'timeInForces', desc: 'Duração', col: 6, class: 'p-left', active: true },
    { id: 3, inputName: 'validityOrder', desc: 'Data do vencimento', col: 6, class: 'p-right', active: true },
    { id: 4, inputName: 'qtd', desc: 'Quantidade', col: 12, class: 'p-0', active: true },
    { id: 5, inputName: 'price', desc: 'Preço', col: 12, class: 'p-0', active: false },
    { id: 6, inputName: 'loss-toggle', desc: 'STOP LOSS', col: 12, class: 'p-0', active: true, showToggle: false },
    { id: 7, inputName: 'stoptrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-loss-content', active: true },
    { id: 8, inputName: 'stoplimit', desc: 'Preço de limite', col: 6, class: 'p-right stop-loss-content', active: true },
    { id: 9, inputName: 'gain-toggle', desc: 'STOP GAIN', col: 12, class: 'p-0 info-row', active: true, showToggle: true },
    { id: 10, inputName: 'targettrigger', desc: 'Preço de disparo', col: 6, class: 'p-left stop-gain-content', active: false },
    { id: 11, inputName: 'targetlimit', desc: 'Preço', col: 12, class: 'p-0 stop-gain-content', active: true },
    {
      id: 12, inputName: 'currentQuantity', desc: 'Posição Atual', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Qtd. em custódia:', col: 9, class: 'title' },
        { id: 2, inputName: 'currentQuantity', desc: '', col: 3, class: 'value right' }
      ]
    },
    {
      id: 13, inputName: 'positionReleased', desc: 'Posição Venda', col: 12, class: 'position', active: true, subInputs: [
        { id: 3, inputName: '', desc: 'Qtd. liberada para venda:', col: 9, class: 'title' },
        { id: 4, inputName: 'quantityReleased', desc: '', col: 3, class: 'value right' },
      ]
    },
    { id: 14, inputName: 'checkMarket', desc: 'Mercado', col: 12, class: 'right checkbox', active: false },
    { id: 15, inputName: 'options', desc: 'Opções Avançadas', col: 12, class: 'p-0 options', active: true },
    { id: 16, inputName: 'maxfloor', desc: 'Quantidade aparente', col: 6, class: 'p-right', active: false },
    { id: 17, inputName: 'minqtd', desc: 'Quantidade mínima', col: 6, class: 'p-right', active: false },
    { id: 18, inputName: 'orderTag', desc: 'Observação', col: 12, class: 'p-0', active: false },
    {
      id: 19, inputName: 'balanceProjOnline', desc: 'Saldo Projetado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Saldo Projetado:', col: 6, class: 'title' },
        { id: 2, inputName: 'balanceProjOnline', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 20, inputName: 'uniqueLimit', desc: 'Limite Operacional', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Limite Operacional:', col: 6, class: 'title' },
        { id: 2, inputName: 'uniqueLimit', desc: '', col: 6, class: 'value right' },
      ]
    },
    {
      id: 21, inputName: 'lastTrade', desc: 'Preço a mercado', col: 12, class: 'position', active: true, subInputs: [
        { id: 1, inputName: '', desc: 'Preço a mercado:', col: 6, class: 'title' },
        { id: 2, inputName: 'lastTrade', desc: '', col: 6, class: 'value right' },
      ]
    }
  ];

  public static BILLET_TYPE_ORDER = [
    { id: 1, webFeeder: TypeOrderEnum.LIMITED, desc: 'Limitada', inputsConfig: Constants.BILLET_WKS_SIMPLE_CONFIG },
    { id: 2, webFeeder: TypeOrderEnum.MARKET, desc: 'Mercado', inputsConfig: Constants.BILLET_WKS_SIMPLE_CONFIG },
    { id: 3, webFeeder: TypeOrderEnum.STOP, desc: 'Stop Simultâneo', inputsConfig: Constants.BILLET_WKS_STOP_CONFIG },
    { id: 4, webFeeder: TypeOrderEnum.STOP_LOSS, desc: 'Stop Loss', inputsConfig: Constants.BILLET_WKS_STOP_LOSS_CONFIG },
  ];

  public static CARD_CONFIG = [
    { name: Constants.TITLE_CARD_ASSET_SUMMARY, type: Constants.WINDOW_NAME_ASSET_SUMMARY, qtdMax: Constants.QTD_MAX_ASSET_SUMMARY, showInput: true, isCardMarketData: true },
    { name: Constants.TITLE_CARD_BOOK, type: Constants.WINDOW_NAME_BOOK, qtdMax: Constants.QTD_MAX_BOOK, showInput: true, isCardMarketData: true },
    { name: Constants.TITLE_CARD_WORKSHEET, type: Constants.WINDOW_NAME_WORK_SHEET, qtdMax: Constants.QTD_MAX_WORKSHEET, showInput: true, isCardMarketData: true },
    { name: Constants.TITLE_CARD_TIMES_TRADES, type: Constants.WINDOW_NAME_TIMES_TRADES, qtdMax: Constants.QTD_MAX_TIMES_TRADE, showInput: true, isCardMarketData: true },
    { name: Constants.TITLE_CARD_QUOTE_CHART, type: Constants.WINDOW_NAME_QUOTE_CHART, qtdMax: Constants.QTD_MAX_CHART, showInput: false, isCardMarketData: true },
    { name: Constants.TITLE_CARD_VOLUME_AT_PRICE, type: Constants.WINDOW_NAME_VOLUME_AT_PRICE, qtdMax: Constants.QTD_MAX_VOLUME_AT_PRICE, showInput: true, isCardMarketData: true },
    { name: Constants.TITLE_CARD_NEWS_WKS, type: Constants.WINDOW_NAME_NEWS_WKS, qtdMax: Constants.QTD_MAX_NEWS_WKS, showInput: false, isCardMarketData: true },
    { name: Constants.TITLE_CARD_HIGH_LOW_DAY, type: Constants.WINDOW_NAME_HIGH_LOW_DAY, qtdMax: Constants.QTD_MAX_HIGH_LOW_DAY, showInput: false, isCardMarketData: true },
    { name: Constants.TITLE_CARD_POSITION_DAY, type: Constants.WINDOW_NAME_POSITION_DAY, qtdMax: Constants.QTD_MAX_POSITION_DAY, showInput: false, isCardMarketData: false },
    { name: Constants.TITLE_CARD_POSITION_BALANCE, type: Constants.WINDOW_NAME_POSITION_BALANCE, qtdMax: Constants.QTD_MAX_POSITION_BALANCE, showInput: false, isCardMarketData: false },
    { name: Constants.TITLE_CARD_ORDER_WKS, type: Constants.WINDOW_NAME_ORDER_WKS, qtdMax: Constants.QTD_MAX_ORDER_WKS, showInput: false, isCardMarketData: false },
    { name: Constants.TITLE_CARD_BILLET_ROOT, type: Constants.WINDOW_NAME_BILLET_ROOT, qtdMax: Constants.QTD_MAX_BILLET_ROOT, showInput: true, isCardMarketData: false },
  ];

  public static MENU_SYSTEM_DEFAULT = [
    {
      id: 0, name: 'WORKSPACE', desc: 'Área de Trabalho', icon: 'monitor', class: 'line w-53', isMarketData: true, isMenuWks: true, active: true,
    },
    {
      id: 1, name: 'CONTENTS', desc: 'Conteúdos', icon: 'contents', class: 'line w-70', isMarketData: true, isMenuWks: false, active: true, isRanking: false, submenus: [
        { id: 0, name: Constants.TITLE_CARD_NEWS_WKS, type: Constants.WINDOW_NAME_NEWS_WKS, desc: 'Investimentos e Notícias', icon: 'top-news', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: AgencyNewsEnum.INVESTIMMENTOS_NOTICIA },
        { id: 1, name: Constants.TITLE_CARD_NEWS_WKS, type: Constants.WINDOW_NAME_NEWS_WKS, desc: 'Notícias', icon: 'contents', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: AgencyNewsEnum.CEDRO },
        { id: 2, name: Constants.TITLE_CARD_MODAL_NEWS, type: Constants.WINDOW_NAME_MODAL_NEWS, desc: 'Pesquisa de Notícias', icon: 'search', component_name: 'ModalNewsComponent', url: '', isMarketData: true, isModal: true, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 4, name: '', type: '', desc: '', icon: '', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: true, active: false, filter: null },
        { id: 5, name: '', type: '', desc: 'Carteiras Recomendadas', icon: 'wallets', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: false, filter: null },
        { id: 6, name: '', type: '', desc: 'Canal no Youtube', icon: 'youtube', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: false, filter: null },
        { id: 7, name: '', type: '', desc: 'Material Educacional', icon: 'question', component_name: '', url: Constants.LINK_URL_RANKED_EDUCATIONAL, isMarketData: false, isModal: true, isLink: true, isRanking: false, isLine: false, active: false, filter: null },
      ]
    },
    {
      id: 2, name: 'TOOLS', desc: 'Ferramentas', icon: 'tools', class: 'line w-65', isMarketData: true, isMenuWks: false, active: true, isRanking: false, submenus: [
        { id: 0, name: Constants.TITLE_CARD_WORKSHEET, type: Constants.WINDOW_NAME_WORK_SHEET, desc: 'Planilha de Cotação', icon: 'quote-sheet', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 1, name: Constants.TITLE_CARD_ASSET_SUMMARY, type: Constants.WINDOW_NAME_ASSET_SUMMARY, desc: 'Resumo do Ativo', icon: 'quote-sumary', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 2, name: Constants.TITLE_CARD_BOOK, type: Constants.WINDOW_NAME_BOOK, desc: 'Livro de Ofertas', icon: 'book-offers', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 4, name: Constants.TITLE_CARD_TIMES_TRADES, type: Constants.WINDOW_NAME_TIMES_TRADES, desc: 'Negócios Realizados', icon: 'currency-alarm', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 5, name: Constants.TITLE_CARD_VOLUME_AT_PRICE, type: Constants.WINDOW_NAME_VOLUME_AT_PRICE, desc: 'Volume por Preço', icon: 'graph-bars', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 6, name: Constants.TITLE_CARD_QUOTE_CHART, type: Constants.WINDOW_NAME_QUOTE_CHART, desc: 'Gráfico', icon: 'graph-pizza', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 7, name: Constants.TITLE_CARD_HIGH_LOW_DAY, type: Constants.WINDOW_NAME_HIGH_LOW_DAY, desc: 'Top: Maiores do dia', icon: 'top-low-trader', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
      ]
    },
    {
      id: 3, name: 'NEGOTIATION', desc: 'Negociação', icon: 'currency-trade', class: 'line w-67', isMarketData: false, isMenuWks: false, active: true, isRanking: false, submenus: [
        { id: 1, name: Constants.TITLE_CARD_BILLET_WKS, type: Constants.WINDOW_NAME_BILLET_ROOT, desc: 'Boleta Simples', icon: 'currency', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: 'SIMPLES' },
        { id: 2, name: Constants.TITLE_CARD_BILLET_QUICK, type: Constants.WINDOW_NAME_BILLET_ROOT, desc: 'Boleta Rápida', icon: 'currency-speed', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: 'RÁPIDA' },
        { id: 3, name: Constants.TITLE_CARD_BILLET_DOM, type: Constants.WINDOW_NAME_BILLET_ROOT, desc: 'Mega DOM', icon: 'dom', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: 'DOM' },
        { id: 4, name: '', type: '', desc: '', icon: '', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: true, active: true, filter: null },
        { id: 5, name: Constants.TITLE_CARD_ORDER_WKS, type: Constants.WINDOW_NAME_ORDER_WKS, desc: 'Ordens do dia', icon: 'order', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 6, name: Constants.TITLE_CARD_POSITION_DAY, type: Constants.WINDOW_NAME_POSITION_DAY, desc: 'Posição do dia', icon: 'currency-trade', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 6, name: Constants.TITLE_CARD_POSITION_BALANCE, type: Constants.WINDOW_NAME_POSITION_BALANCE, desc: 'Posição Financeira', icon: 'currency-trade', component_name: '', url: '', isMarketData: false, isModal: false, isLink: false, isRanking: false, isLine: false, active: true, filter: null },
        { id: 7, name: '', type: '', desc: '', icon: '', component_name: '', url: '', isMarketData: true, isModal: false, isLink: false, isRanking: false, isLine: true, active: true, filter: null },
        {
          id: 8, name: 'REPORTS', desc: 'Relatórios', icon: 'reports', class: 'line w-72', isMarketData: true, isMenuWks: false, active: true, submenus: [
            { id: 0, name: Constants.TITLE_CARD_MODAL_PATRIMONY, type: Constants.WINDOW_NAME_MODAL_PATRIMONY, desc: 'Patrimônio', icon: 'currency', component_name: 'BalanceConsultComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
            { id: 1, name: Constants.TITLE_CARD_MODAL_CUSTODY, type: Constants.WINDOW_NAME_MODAL_CUSTODY, desc: 'Minha Custódia', icon: 'money', component_name: 'CustodyConsultComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
            { id: 2, name: Constants.TITLE_CARD_MODAL_FINANCIAL_STATEMENT, type: Constants.WINDOW_NAME_MODAL_FINANCIAL_STATEMENT, desc: 'Extrato Financeiro', icon: 'book-extract', component_name: 'ExtractFinancialComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
            { id: 3, name: Constants.TITLE_CARD_MODAL_ORDER, type: Constants.WINDOW_NAME_MODAL_ORDER, desc: 'Histórico de Ordens', icon: 'order', component_name: 'OrdersHistoryComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
            // TODO: verificar quando voltar 
            // { id: 4, name: Constants.TITLE_CARD_MODAL_BROKERAGE, type: Constants.WINDOW_NAME_MODAL_BROKERAGE, desc: 'Nota de Corretagem', icon: 'book-history', component_name: 'BrokerageNoteComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
            { id: 5, name: Constants.TITLE_CARD_MODAL_DEPOSIT, type: Constants.WINDOW_NAME_MODAL_DEPOSIT, desc: 'Depósito/Resgate', icon: 'reset', component_name: 'DepositComponent', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, active: true, filter: null },
          ]
        },
      ]
    },
    {
      id: 4, name: 'MARKETS', desc: 'Mercados', icon: 'currency-trade', class: 'line w-72', isMarketData: false, isMenuWks: false, active: false, isRanking: false, submenus: [
        { id: 0, name: '', desc: 'Resumo das Bolsas', icon: 'summary', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
        { id: 1, name: '', desc: 'World Indices', icon: 'world', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
        { id: 2, name: '', desc: 'Moedas', icon: 'coin', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
      ]
    },
    {
      id: 5, name: 'CHALLENGE', desc: 'Desafio', icon: 'currency-trade', class: 'line w-77', isMarketData: false, isMenuWks: false, active: true, isRanking: true, submenus: [
        { id: 0, name: '', type: '', desc: 'Ranking', icon: 'ranking-two', component_name: '', url: Constants.LINK_URL_RANKED, isMarketData: true, isModal: false, isLink: true, isRanking: true, active: true },
        { id: 1, name: '', type: '', desc: 'Material Educacional', icon: 'book', component_name: '', url: Constants.LINK_URL_RANKED_EDUCATIONAL, isMarketData: false, isModal: true, isLink: true, isRanking: true, active: true },
      ]
    },
    {
      id: 6, name: 'ASSESSOR', desc: 'Assessor', icon: 'currency-trade', class: 'line w-72', isMarketData: false, isMenuWks: false, active: false, isRanking: false, submenus: [
        { id: 0, name: '', desc: 'Menu 01', icon: 'book', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
        { id: 1, name: '', desc: 'Menu 02', icon: 'book', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
        { id: 2, name: '', desc: 'Menu 03', icon: 'book', component_name: '', url: '', isMarketData: false, isModal: true, isLink: false, isRanking: false, isLine: false, active: true },
      ]
    }
  ];

  public static assetsummary_settings = {
    type: Constants.WINDOW_NAME_ASSET_SUMMARY,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: false,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 1
    }
  };

  public static worksheet_settings = {
    type: Constants.WINDOW_NAME_WORK_SHEET,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 2,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 300,
      minItemRows: 1,
      maxItemCols: 300,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 2500
    }
  };

  public static timestrades_settings = {
    type: Constants.WINDOW_NAME_TIMES_TRADES,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 100
    }
  };

  public static volumeatprice_settings = {
    type: Constants.WINDOW_NAME_VOLUME_AT_PRICE,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static book_settings = {
    type: Constants.WINDOW_NAME_BOOK,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      resizeEnabled: true,
      dragEnabled: true,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static quotechart_settings = {
    type: Constants.WINDOW_NAME_QUOTE_CHART,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 2,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 10,
      minItemRows: 1,
      maxItemCols: 10,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 2500
    }
  };

  public static billetquick_settings = {
    type: Constants.WINDOW_NAME_BILLET_QUICK,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static billetroot_settings = {
    type: Constants.WINDOW_NAME_BILLET_ROOT,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static billetwks_settings = {
    type: Constants.WINDOW_NAME_BILLET_WKS,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static newswks_settings = {
    type: Constants.WINDOW_NAME_NEWS_WKS,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 2,
      dragEnabled: true,
      resizeEnabled: false,
      maxItemRows: 100,
      minItemRows: 2,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 2,
      maxItemArea: 100
    }
  };

  public static highlowday_settings = {
    type: Constants.WINDOW_NAME_HIGH_LOW_DAY,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: false,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 1
    }
  };

  public static positionday_settings = {
    type: Constants.WINDOW_NAME_POSITION_DAY,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 2,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 2500
    }
  };

  public static orderwks_settings = {
    type: Constants.WINDOW_NAME_ORDER_WKS,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 2,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: true,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 2,
      minItemArea: 2,
      maxItemArea: 2500
    }
  };

  public static positionbalancewks_settings = {
    type: Constants.WINDOW_NAME_POSITION_BALANCE,
    showInGridster: true,
    position: {
      x: 0,
      y: 0,
      cols: 1,
      rows: 1,
      dragEnabled: true,
      resizeEnabled: false,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemCols: 100,
      minItemCols: 1,
      minItemArea: 1,
      maxItemArea: 1
    }
  };

  public static items_settingsArr = [
    Constants.assetsummary_settings, Constants.worksheet_settings, Constants.timestrades_settings,
    Constants.volumeatprice_settings, Constants.book_settings, Constants.quotechart_settings,
    Constants.billetquick_settings, Constants.billetwks_settings, Constants.newswks_settings,
    Constants.highlowday_settings, Constants.positionday_settings, Constants.orderwks_settings,
    Constants.billetroot_settings, Constants.positionbalancewks_settings
  ];


  // Options header to diferent request
  public static httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
      'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE'
    })
  };

  public static worksheetCols = [
    { id: 0, field: 'ativo', header: 'ATIVO', class: 'txt-left', headerClass: 'txt-left', width: 90, isDefault: true, fixedItem: true },
    { id: 1, field: 'description', header: 'NOME', class: 'txt-left', headerClass: 'txt-left', width: 170, isDefault: true },
    { id: 2, field: 'lastTrade', header: 'ÚLTIMO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 3, field: 'variation', header: '%', class: 'txt-center', headerClass: 'txt-center', width: 55, isDefault: true },
    { id: 4, field: 'bid', header: 'COMPRA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 5, field: 'ask', header: 'VENDA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 6, field: 'high', header: 'MÁX.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 7, field: 'low', header: 'MÍN.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 8, field: 'open', header: 'ABERTURA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 9, field: 'previous', header: 'FECHAMENTO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 10, field: 'timeUpdate', header: 'HORA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 11, field: 'volumeAmount', header: 'VOLUME', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 12, field: 'volumeFinancier', header: 'VOLUME FIN.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 13, field: 'quantity', header: 'QTD. NEGÓCIOS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 14, field: 'quantityLast', header: 'QTD. ÚLT. NEG.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 15, field: 'adjustment', header: 'AJUSTE', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 16, field: 'previousAdjustPrice', header: 'AJUSTE ANT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: true },
    { id: 17, field: 'coinVariation', header: 'VARIAÇÃO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 18, field: 'varAjustp', header: 'VAR. AJUS. %', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 19, field: 'varAjust', header: 'VAR. AJUS.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 20, field: 'varTeor', header: 'VAR. TEOR. %', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 21, field: 'dateTrade', header: 'DATA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 22, field: 'hourLastTrade', header: 'HORA ULT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 23, field: 'volAccBid', header: 'VOL. ACUM. COMP.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 17
    { id: 24, field: 'volAccAsk', header: 'VOL. ACUM. VEND.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 18
    { id: 25, field: 'volumeBetterBid', header: 'QTD. C.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 26, field: 'volumeBetterAsk', header: 'QTD. V.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 27, field: 'previousWeek', header: 'FECH. SEMANA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 36
    { id: 28, field: 'previousMonth', header: 'FECH. MÊS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 37
    { id: 29, field: 'previousYear', header: 'FECH. ANO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 38
    { id: 30, field: 'openLastDay', header: 'AB. DIA ANT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 39
    { id: 31, field: 'highPriceLastDay', header: 'MAX DIA ANT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 40
    { id: 32, field: 'lowPriceLastDay', header: 'MIN. DIA ANT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 41
    { id: 33, field: 'average', header: 'PREÇO MÉDIO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 34, field: 'vhDay', header: 'VH DIA', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 43
    // { id: 35, field: 'marketType', header: 'CÓD. MERCADO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 36, field: 'assetType', header: 'CÓD. TIPO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 37, field: 'loteDefault', header: 'LOTE PADRÃO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 38, field: 'classification', header: 'CLASSIFIC.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 39, field: 'quotationForm', header: 'FORMA COT.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 40, field: 'dateLastNegotiation', header: 'DATA ULT. NEG.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 54
    { id: 41, field: 'directionUnansweredQty', header: 'INDIC. RESTO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 42, field: 'unansweredQty', header: 'QTD. NÃO ATEND.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 43, field: 'timeToOpen', header: 'HORA PROG. AB. PAP.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 44, field: 'timeReprogrammedToOpen', header: 'HORA REPROG. AB. PAP.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 45, field: 'expirationDate', header: 'DATA VENC.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 46, field: 'expiration', header: 'EXPIRADO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 47, field: 'quantitySymbol', header: 'TOT. PAPÉIS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 48, field: 'expiration', header: 'EXPIRADO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 49, field: 'inTheWeek', header: 'STATUS INSTR.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 50, field: 'typeOption', header: 'TIPO OPÇÃO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 72
    { id: 51, field: 'theoryPrice', header: 'PREÇO TEÓR. AB.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 52, field: 'theoryQuantity', header: 'QTD. TEÓR.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 53, field: 'volAVG20', header: 'VOL. MÉD.(20 D)', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 94
    { id: 54, field: 'calculoWeeklyVariation', header: '% 1 SEM', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 55, field: 'lastTrade1Month', header: 'FECH. 1 MÊS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 56, field: 'calculoMonthlyVariation', header: '% 1 MÊS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 57, field: 'lastTrade1Year', header: 'FECH. 1 ANO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 58, field: 'calculoYearlyVariation', header: '% 1 ANO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    // { id: 59, field: 'tickSize', header: 'CASAS DECIMAIS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false },
    { id: 60, field: 'deltaVolumeCurrentTime', header: 'VOL. ACUM.', class: 'txt-center', headerClass: 'txt-center', width: 100, isDefault: false },
    { id: 61, field: 'deltaVolumeAccumulatedHour', header: 'VOL. HORA', class: 'txt-center', headerClass: 'txt-center', width: 95, isDefault: false },
    { id: 62, field: 'status', header: 'STATUS', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BOVESPA
    { id: 63, field: 'exercisePrice', header: 'PREÇO EXERCÍCIO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BOVESPA
    // { id: 64, field: 'groupPhase', header: 'FASE DO GRUPO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 88 BOVESPA
    { id: 65, field: 'quantityOpenedContractNumber', header: 'CONTRATOS AB.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 66, field: 'businesDaysToExpirationDate', header: 'DIAS ÚTEIS VENC.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 67, field: 'calendarDaysToExpirationDate', header: 'DIAS VENC.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    // { id: 68, field: 'securityId', header: 'SECURITY ID', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 105 BMF
    { id: 69, field: 'tickDirection', header: '[T]', class: 'txt-center', headerClass: 'txt-center', width: 38, isDefault: false }, // TODO DONT EXIST MODEL 106 BMF
    { id: 70, field: 'tunnelUpperLimit', header: 'LIM. MAX. TÚNEL', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 71, field: 'tunnelLowerLimit', header: 'LIM. MIN. TÚNEL', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 72, field: 'minimumIncrement', header: 'INCREM. MÍN.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    // { id: 73, field: 'exercisePriceOption', header: 'PREÇO EXERC. OPÇÃO', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO DONT EXIST MODEL 121 BMF
    { id: 74, field: 'contractMultiplier', header: 'FATOR', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 75, field: 'adjustCurrentRate', header: 'AJUSTE (TAXA)', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 76, field: 'adjustPreviousRate', header: 'AJ. ANT. (TAXA)', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    { id: 77, field: 'withdrawalsNumberUntilDueDate', header: 'SAQUES ATÉ VENC.', class: 'txt-center', headerClass: 'txt-center', width: 90, isDefault: false }, // TODO BMF
    // { id: 78, field: 'variationArrow', header: '[S]', class: 'txt-center', headerClass: 'txt-center', width: 37, isDefault: true },
  ];
  public static DEFAULT_INTERVAL = '15';
  public static BLANK_CHART = ' ';
  // Paths constants
  public static HOME_WKS_PATH = '/home/workspace';

  public static ERROR_400_TITLE = 'Solicitação Inválida';
  public static ERROR_400_ICON = '400';
  public static ERROR_400_BUTTON = 'Início';
  public static ERROR_400_TEXT = 'O link que você clicou pode estar quebrado ou a página pode ter sido removida.';

  public static ERROR_403_TITLE = 'Acesso proibido!';
  public static ERROR_403_ICON = '403';
  public static ERROR_403_BUTTON = 'Login';
  public static ERROR_403_TEXT = 'Você não tem permissão para acessar este link. Por favor, contate um administrador.';

  public static ERROR_404_TITLE = 'Página não encontrada!';
  public static ERROR_404_ICON = '404';
  public static ERROR_404_BUTTON = 'Início';
  public static ERROR_404_TEXT = 'O link que você clicou pode estar quebrado ou a página pode ter sido removida.';

  public static ERROR_TIMEOUT_TITLE = 'Sua sessão será encerrada em 55 segundos.';
  public static ERROR_TIMEOUT_ICON = 'session';
  public static ERROR_TIMEOUT_BUTTON = 'CONTINUAR';
  public static ERROR_TIMEOUT_TEXT = 'Para manter sua sessão ativa, clique em "continuar"';
  public static ERROR_ERROR_TITLE = 'Ocorreu um erro.';
  public static ERROR_ERROR_ICON = 'error';
  public static ERROR_ERROR_BUTTON = 'RECARREGAR PÁGINA';
  public static ERROR_ERROR_TEXT = 'Algo deu errado. Experimente recarregar a página.';
  public static ERROR_DENIED_TITLE = 'Acesso negado!';
  public static ERROR_DENIED_ICON = 'permission';
  public static ERROR_DENIED_BUTTON = 'Entre em contato';
  public static ERROR_DENIED_TEXT = 'No momento, você não tem permissão para acessar o Home Broker.';
  public static ERROR_EXPIRED_TITLE = 'Como o tempo voa. Sua sessão expirou.';
  public static ERROR_EXPIRED_ICON = 'session';
  public static ERROR_EXPIRED_BUTTON = 'LOGIN';
  public static ERROR_EXPIRED_TEXT = 'Se você quiser continuar navegando faça o login novamente';
  public static ERROR_GENERIC_TITLE = 'Ops!';
  public static ERROR_MULTIPLE_CHARTS_TITLE = 'Mais de um gráfico para mesma empresa';
  public static ERROR_MULTIPLE_CHARTS_TEXT = 'Não é possivel selecionar mais de um gráfico pertencente a mesma empresa.';
  public static ERROR_WF_CONECTION_TEXT = 'Conexão com os servidores perdida.<br>[QTD] Reconectando aos servidores.';
  public static ERROR_WF_CONECTION_RECONNECT = 'Não foi possível estabelecer conexão com os servidores.';
  public static ERROR_WF_CONECTION_RECONNECT2 = 'Tente novamente mais tarde ou efetue o login novamente';
  public static ERROR_SYSTEM_TEXT = 'Ocorreu um erro que impede a correta execução do sistema.';
  public static ERROR_WKS_CONECTION_TEXT = `Tivemos um problema para carregar a sua área de trabalho.
  <br> O que deseja fazer, recarregar a sua área de trabalho ou usar uma offline?`;
  public static ERROR_WKS_ADD_CARD = `Ação não permitida em uma área de trabalho offline.`;
  public static ERROR_REQUEST = 'Ocorreu um erro durante a requisição de solicitação de listagem de clientes. Tente novamente mais tarde!';

  // Youtube API constants
  public static HB_DOMAIN = 'trade.fastmarkets.com.br'; // TODO change to production
  public static YOUTUBE_URL = 'https://www.youtube.com/';
  public static CHAT_PARAMS = '&amp;embed_domain=' + Constants.HB_DOMAIN + '&amp;wmode=opaque';
  public static CHAT_URL = Constants.YOUTUBE_URL + 'live_chat?v=';
  public static VIDEO_PARAMS = '?feature=oembed&amp;wmode=opaque';
  public static VIDEO_URL = Constants.YOUTUBE_URL + 'embed/';
  // public static SEARCH_VIDEO_INTERVAL = 60000; // 1 minuto
  public static SEARCH_VIDEO_INTERVAL = 30000; // 20s segundos
  public static PROMO_URL = 'http://promo.cedrotech.com/fast-trade-download-plataforma-3-0';

  public static YOUTUBE_CHANNEL_ID = 'UCGhbswoCt_QUHXvzdywH3TQ';                // FAST TRADE
  // public static YOUTUBE_CHANNEL_ID = 'UC7Nnkn76ijG-vM4mfhp4Cjw';             // Levante Channel Id
  // public static YOUTUBE_CHANNEL_ID = 'UCJhjE7wbdYAae1G25m0tHAA';             // Teste
  public static GOOGLE_SERVICE_KEY = 'AIzaSyA8j7g-t8RI3r8SpEs2OA9BZr3aPZpSBu0'; // Google service key
  public static OFFLINE_DEFAULT_WORKSPACE = [
    {
      "Id": "default",
      "UserName": "",
      "Name": "Offline",
      "Active": true,
      "IndexTab": 1,
      "IsPrivate": 0,
      "WorkspaceType": 1,
      "JsonData": "{\"title\":\"Offline\",\"indexTab\":1,\"content\":[{\"id\":0,\"symbol\":\"\",\"company\":\"\",\"type\":\"worksheet\",\"workspaceId\":33,\"position\":{\"x\":0,\"y\":0,\"cols\":4,\"rows\":1,\"resizeEnabled\":true,\"minItemRows\":1,\"minItemCols\":1},\"showInGridster\":true},{\"id\":1,\"symbol\":\"IBOV\",\"company\":\"\",\"type\":\"asset-summary\",\"workspaceId\":33,\"position\":{\"x\":2,\"y\":1,\"cols\":1,\"rows\":1,\"resizeEnabled\":false,\"minItemRows\":1,\"minItemCols\":1},\"showInGridster\":true},{\"id\":2,\"symbol\":\"petr4\",\"company\":\"\",\"type\":\"book\",\"workspaceId\":33,\"position\":{\"x\":0,\"y\":1,\"cols\":1,\"rows\":2,\"resizeEnabled\":false,\"minItemRows\":2,\"minItemCols\":1},\"showInGridster\":true},{\"id\":3,\"symbol\":\"PETR4\",\"company\":\"\",\"type\":\"volume-at-price\",\"workspaceId\":33,\"position\":{\"x\":1,\"y\":1,\"cols\":1,\"rows\":2,\"resizeEnabled\":false,\"minItemRows\":2,\"minItemCols\":1},\"showInGridster\":true},{\"id\":4,\"symbol\":\"ibov\",\"company\":\"\",\"type\":\"quote-chart\",\"workspaceId\":33,\"position\":{\"x\":2,\"y\":2,\"cols\":2,\"rows\":1,\"resizeEnabled\":true,\"minItemRows\":1,\"minItemCols\":1},\"showInGridster\":true},{\"id\":5,\"symbol\":\"petr4\",\"company\":\"PETROBRAS\",\"type\":\"asset-summary\",\"workspaceId\":33,\"position\":{\"x\":3,\"y\":1,\"cols\":1,\"rows\":1,\"resizeEnabled\":false,\"minItemRows\":1,\"minItemCols\":1},\"showInGridster\":true}]}"
    }
  ];

  public static COUNTRY_STATES = [
    { name: 'Acre', abbreviation: 'AC' },
    { name: 'Alagoas', abbreviation: 'AL' },
    { name: 'Amapá', abbreviation: 'AP' },
    { name: 'Amazonas', abbreviation: 'AM' },
    { name: 'Bahia', abbreviation: 'BA' },
    { name: 'Ceará', abbreviation: 'CE' },
    { name: 'Distrito Federal', abbreviation: 'DF' },
    { name: 'Espírito Santo', abbreviation: 'ES' },
    { name: 'Goiás', abbreviation: 'GO' },
    { name: 'Maranhão', abbreviation: 'MA' },
    { name: 'Mato Grosso', abbreviation: 'MT' },
    { name: 'Mato Grosso do Sul', abbreviation: 'MS' },
    { name: 'Minas Gerais', abbreviation: 'MG' },
    { name: 'Pará', abbreviation: 'PA' },
    { name: 'Paraíba', abbreviation: 'PB' },
    { name: 'Paraná', abbreviation: 'PR' },
    { name: 'Pernambuco', abbreviation: 'PE' },
    { name: 'Piauí', abbreviation: 'PI' },
    { name: 'Rio de Janeiro', abbreviation: 'RJ' },
    { name: 'Rio Grande do Norte', abbreviation: 'RN' },
    { name: 'Rio Grande do Sul', abbreviation: 'RS' },
    { name: 'Rondônia', abbreviation: 'RO' },
    { name: 'Roraima', abbreviation: 'RR' },
    { name: 'Santa Catarina', abbreviation: 'SC' },
    { name: 'São Paulo', abbreviation: 'SP' },
    { name: 'Sergipe', abbreviation: 'SE' },
    { name: 'Tocantins', abbreviation: 'TO' }
  ];

  public static PLAN_FAST_TRADE_TYPE = [
    {
      id: PlanFastTradeTypeEnum.DEMO, icon: '', message: 'Olá [USERNAME]! Restam [DAYS] dia(s) para encerrar seu período de teste da plataforma.', title: 'Período de teste', alertType: ALERT_TYPE.error,
      detail: '<p><b>[USERNAME]</b>, você ainda tem <b>[DAYS] dia(s)</b> para testar a plataforma gratuitamente.</p><p>Para contratar o Fast Trade, escolha o plano que preferir e desfrute das funcionalidades da plataforma!</p>',
      labelBtnSubimit: 'Assinar plano', btnConfirmText: 'CONTRATAR FAST TRADE', btnCancelText: 'Fechar'
    },
    {
      id: PlanFastTradeTypeEnum.DEMO_EXPIRED, icon: '', message: 'Olá [USERNAME]! Restam [DAYS] dia(s) para encerrar seu período de teste da plataforma.', title: 'Período de teste', alertType: ALERT_TYPE.error,
      detail: '<p>Olá, <b>[USERNAME]</b>! Amanhã <b>[DATE]</b> expira seu período de teste gratuito da plataforma.</p><p>Contrate o plano que melhor te atende para usufruir de todas as funcionalidades do Fast Trade!</p>',
      labelBtnSubimit: 'Assinar plano', btnConfirmText: 'CONTRATAR FAST TRADE', btnCancelText: 'Fechar'
    },
    {
      id: PlanFastTradeTypeEnum.DEMO_INATIVE, icon: '', message: 'Olá, [USERNAME]! Seu período de acesso gratuito acabou!', title: 'Período de teste', alertType: ALERT_TYPE.error,
      detail: '<p>Olá, <b>[USERNAME]</b>! Seu período de acesso gratuito acabou! Para continuar, escolha uma das opções abaixo.</p>',
      labelBtnSubimit: '', btnConfirmText: 'CONTRATAR FAST TRADE', btnCancelText: 'Fechar'
    },
    {
      id: PlanFastTradeTypeEnum.FREE, icon: '', message: 'Olá [USERNAME]! Você está usando a versão gratuita da plataforma, lembre-se que possui um delay de 15 minutos', title: 'Versão gratuita', alertType: ALERT_TYPE.info,
      detail: '<p><b>[USERNAME]</b>, você está usando a versão gratuita, por isso ela apresenta um delay de 15 minutos.<p/> <p>Para ter acesso a plataforma em tempo real, contrate um dos planos do Fast Trade.</p> ',
      labelBtnSubimit: 'Assinar plano', btnConfirmText: 'CONTRATAR FAST TRADE', btnCancelText: 'Fechar'
    },
  ];
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const SINACOR_ERROR_REGISTER_MESSAGE_TITLE_DEFAULT = 'No momento a corretora selecionada não possui integração automática.';
export const SINACOR_ERROR_REGISTER_MESSAGE_DESCRIPTION_DEFAULT = 'Por favor entre em contato conosco para que possamos dar andamento em seu cadastro.';

export const SINACOR_ERROR_REGISTER_MESSAGE = {
  "TERRA": {
    title: 'No momento a corretora selecionada não possui integração automática.',
    description: 'Entre em contato com a corretora e solicite os dados de acesso.'
  },
  "BTG": {
    title: 'Para usar o FAST TRADE nesta corretora, por favor entre na área de Plataformas no site da Corretora, e escolha o FAST TRADE.',
    description: 'Se tiver qualquer dúvida, entre em contato conosco.'
  },
  "EASYNVEST": {
    title: 'A criação de usuários nesta corretora é feita diretamento no site dela.',
    description: 'Entre no site da corretora, navegue até a área de plataformas, e contrate diretamente por lá'
  },
  "RB": {
    title: 'No momento a corretora selecionada não possui integração automática.',
    description: 'Entre em contato com a corretora e solicite os dados de acesso.'
  },
  "XP": {
    title: 'Para usar o FAST TRADE nesta corretora, por favor entre na área de Plataformas no site da Corretora, e escolha o FAST TRADE.',
    description: 'Se tiver qualquer dúvida, entre em contato conosco.'
  },
  "CLEAR": {
    title: 'Para usar o FAST TRADE nesta corretora, por favor entre na área de Plataformas no site da Corretora, e escolha o FAST TRADE.',
    description: 'Se tiver qualquer dúvida, entre em contato conosco.'
  },
  "RICO": {
    title: 'Para usar o FAST TRADE nesta corretora, por favor entre na área de Plataformas no site da Corretora, e escolha o FAST TRADE.',
    description: 'Se tiver qualquer dúvida, entre em contato conosco.'
  },
  "MODAL": {
    title: 'Para usar o FAST TRADE nesta corretora, por favor entre na área de Plataformas no site da Corretora, e escolha o FAST TRADE.',
    description: 'Se tiver qualquer dúvida, entre em contato conosco.'
  },
};

export const BANKS = [
  {
    "value": "001",
    "label": "Banco do Brasil S.A."
  },
  {
    "value": "003",
    "label": "Banco da Amazônia S.A."
  },
  {
    "value": "004",
    "label": "Banco do Nordeste do Brasil S.A."
  },
  {
    "value": "007",
    "label": "Banco Nacional de Desenvolvimento Econômico e Social BNDES"
  },
  {
    "value": "010",
    "label": "Credicoamo Crédito Rural Cooperativa"
  },
  {
    "value": "011",
    "label": "Credit Suisse Hedging-Griffo Corretora de Valores S.A."
  },
  {
    "value": "012",
    "label": "Banco Inbursa S.A."
  },
  {
    "value": "014",
    "label": "Natixis Brasil S.A. Banco Múltiplo"
  },
  {
    "value": "015",
    "label": "UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
  },
  {
    "value": "016",
    "label": "Coop de Créd. Mútuo dos Despachantes de Trânsito de SC e Rio Grande do Sul"
  },
  {
    "value": "017",
    "label": "BNY Mellon Banco S.A."
  },
  {
    "value": "018",
    "label": "Banco Tricury S.A."
  },
  {
    "value": "021",
    "label": "Banestes S.A. Banco do Estado do Espírito Santo"
  },
  {
    "value": "024",
    "label": "Banco Bandepe S.A."
  },
  {
    "value": "025",
    "label": "Banco Alfa S.A."
  },
  {
    "value": "029",
    "label": "Banco Itaú Consignado S.A."
  },
  {
    "value": "033",
    "label": "Banco Santander (Brasil) S. A."
  },
  {
    "value": "036",
    "label": "Banco Bradesco BBI S.A."
  },
  {
    "value": "037",
    "label": "Banco do Estado do Pará S.A."
  },
  {
    "value": "040",
    "label": "Banco Cargill S.A."
  },
  {
    "value": "041",
    "label": "Banco do Estado do Rio Grande do Sul S.A."
  },
  {
    "value": "047",
    "label": "Banco do Estado de Sergipe S.A."
  },
  {
    "value": "060",
    "label": "Confidence Corretora de Câmbio S.A."
  },
  {
    "value": "062",
    "label": "Hipercard Banco Múltiplo S.A."
  },
  {
    "value": "063",
    "label": "Banco Bradescard S.A."
  },
  {
    "value": "064",
    "label": "Goldman Sachs do Brasil  Banco Múltiplo S. A."
  },
  {
    "value": "065",
    "label": "Banco AndBank (Brasil) S.A."
  },
  {
    "value": "066",
    "label": "Banco Morgan Stanley S. A."
  },
  {
    "value": "069",
    "label": "Banco Crefisa S.A."
  },
  {
    "value": "070",
    "label": "Banco de Brasília S.A."
  },
  {
    "value": "074",
    "label": "Banco J. Safra S.A."
  },
  {
    "value": "075",
    "label": "Banco ABN Amro S.A."
  },
  {
    "value": "076",
    "label": "Banco KDB do Brasil S.A."
  },
  {
    "value": "077",
    "label": "Banco Inter S.A."
  },
  {
    "value": "078",
    "label": "Haitong Banco de Investimento do Brasil S.A."
  },
  {
    "value": "079",
    "label": "Banco Original do Agronegócio S.A."
  },
  {
    "value": "080",
    "label": "BT Corretora de Câmbio Ltda."
  },
  {
    "value": "081",
    "label": "BBN Banco Brasileiro de Negocios S.A."
  },
  {
    "value": "082",
    "label": "Banco Topazio S.A."
  },
  {
    "value": "083",
    "label": "Banco da China Brasil S.A."
  },
  {
    "value": "084",
    "label": "Uniprime Norte do Paraná - Cooperativa de Crédito Ltda."
  },
  {
    "value": "085",
    "label": "Cooperativa Central de Crédito Urbano - Cecred"
  },
  {
    "value": "089",
    "label": "Cooperativa de Crédito Rural da Região da Mogiana"
  },
  {
    "value": "091",
    "label": "Central de Cooperativas de Economia e Crédito Mútuo do Est RS - Unicred"
  },
  {
    "value": "092",
    "label": "BRK S.A. Crédito, Financiamento e Investimento"
  },
  {
    "value": "093",
    "label": "Pólocred Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte"
  },
  {
    "value": "094",
    "label": "Banco Finaxis S.A."
  },
  {
    "value": "095",
    "label": "Banco Confidence de Câmbio S.A."
  },
  {
    "value": "096",
    "label": "Banco BMFBovespa de Serviços de Liquidação e Custódia S/A"
  },
  {
    "value": "097",
    "label": "Cooperativa Central de Crédito Noroeste Brasileiro Ltda - CentralCredi"
  },
  {
    "value": "098",
    "label": "Credialiança Cooperativa de Crédito Rural"
  },
  {
    "value": "099",
    "label": "Uniprime Central – Central Interestadual de Cooperativas de Crédito Ltda."
  },
  {
    "value": "100",
    "label": "Planner Corretora de Valores S.A."
  },
  {
    "value": "101",
    "label": "Renascença Distribuidora de Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "102",
    "label": "XP Investimentos Corretora de Câmbio Títulos e Valores Mobiliários S.A."
  },
  {
    "value": "104",
    "label": "Caixa Econômica Federal"
  },
  {
    "value": "105",
    "label": "Lecca Crédito, Financiamento e Investimento S/A"
  },
  {
    "value": "107",
    "label": "Banco Bocom BBM S.A."
  },
  {
    "value": "108",
    "label": "PortoCred S.A. Crédito, Financiamento e Investimento"
  },
  {
    "value": "111",
    "label": "Oliveira Trust Distribuidora de Títulos e Valores Mobiliários S.A."
  },
  {
    "value": "113",
    "label": "Magliano S.A. Corretora de Cambio e Valores Mobiliarios"
  },
  {
    "value": "114",
    "label": "Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP"
  },
  {
    "value": "117",
    "label": "Advanced Corretora de Câmbio Ltda."
  },
  {
    "value": "118",
    "label": "Standard Chartered Bank (Brasil) S.A. Banco de Investimento"
  },
  {
    "value": "119",
    "label": "Banco Western Union do Brasil S.A."
  },
  {
    "value": "120",
    "label": "Banco Rodobens SA"
  },
  {
    "value": "121",
    "label": "Banco Agibank S.A."
  },
  {
    "value": "122",
    "label": "Banco Bradesco BERJ S.A."
  },
  {
    "value": "124",
    "label": "Banco Woori Bank do Brasil S.A."
  },
  {
    "value": "125",
    "label": "Brasil Plural S.A. Banco Múltiplo"
  },
  {
    "value": "126",
    "label": "BR Partners Banco de Investimento S.A."
  },
  {
    "value": "127",
    "label": "Codepe Corretora de Valores e Câmbio S.A."
  },
  {
    "value": "128",
    "label": "MS Bank S.A. Banco de Câmbio"
  },
  {
    "value": "129",
    "label": "UBS Brasil Banco de Investimento S.A."
  },
  {
    "value": "130",
    "label": "Caruana S.A. Sociedade de Crédito, Financiamento e Investimento"
  },
  {
    "value": "131",
    "label": "Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda."
  },
  {
    "value": "132",
    "label": "ICBC do Brasil Banco Múltiplo S.A."
  },
  {
    "value": "133",
    "label": "Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e"
  },
  {
    "value": "134",
    "label": "BGC Liquidez Distribuidora de Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "135",
    "label": "Gradual Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
  },
  {
    "value": "136",
    "label": "Confederação Nacional das Cooperativas Centrais Unicred Ltda – Unicred do Brasil"
  },
  {
    "value": "137",
    "label": "Multimoney Corretora de Câmbio Ltda"
  },
  {
    "value": "138",
    "label": "Get Money Corretora de Câmbio S.A."
  },
  {
    "value": "139",
    "label": "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo"
  },
  {
    "value": "140",
    "label": "Easynvest - Título Corretora de Valores SA"
  },
  {
    "value": "142",
    "label": "Broker Brasil Corretora de Câmbio Ltda."
  },
  {
    "value": "143",
    "label": "Treviso Corretora de Câmbio S.A."
  },
  {
    "value": "144",
    "label": "Bexs Banco de Câmbio S.A."
  },
  {
    "value": "145",
    "label": "Levycam - Corretora de Câmbio e Valores Ltda."
  },
  {
    "value": "146",
    "label": "Guitta Corretora de Câmbio Ltda."
  },
  {
    "value": "149",
    "label": "Facta Financeira S.A. - Crédito Financiamento e Investimento"
  },
  {
    "value": "157",
    "label": "ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "159",
    "label": "Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor"
  },
  {
    "value": "163",
    "label": "Commerzbank Brasil S.A. - Banco Múltiplo"
  },
  {
    "value": "169",
    "label": "Banco Olé Bonsucesso Consignado S.A."
  },
  {
    "value": "172",
    "label": "Albatross Corretora de Câmbio e Valores S.A"
  },
  {
    "value": "173",
    "label": "BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A."
  },
  {
    "value": "174",
    "label": "Pernambucanas Financiadora S.A. Crédito, Financiamento e Investimento"
  },
  {
    "value": "177",
    "label": "Guide Investimentos S.A. Corretora de Valores"
  },
  {
    "value": "180",
    "label": "CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "182",
    "label": "Dacasa Financeira S/A - Sociedade de Crédito, Financiamento e Investimento"
  },
  {
    "value": "183",
    "label": "Socred S.A. - Sociedade de Crédito ao Microempreendedor"
  },
  {
    "value": "184",
    "label": "Banco Itaú BBA S.A."
  },
  {
    "value": "188",
    "label": "Ativa Investimentos S.A. Corretora de Títulos Câmbio e Valores"
  },
  {
    "value": "189",
    "label": "HS Financeira S/A Crédito, Financiamento e Investimentos"
  },
  {
    "value": "190",
    "label": "Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do Rio"
  },
  {
    "value": "191",
    "label": "Nova Futura Corretora de Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "194",
    "label": "Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "196",
    "label": "Fair Corretora de Câmbio S.A."
  },
  {
    "value": "197",
    "label": "Stone Pagamentos S.A."
  },
  {
    "value": "204",
    "label": "Banco Bradesco Cartões S.A."
  },
  {
    "value": "208",
    "label": "Banco BTG Pactual S.A."
  },
  {
    "value": "212",
    "label": "Banco Original S.A."
  },
  {
    "value": "213",
    "label": "Banco Arbi S.A."
  },
  {
    "value": "217",
    "label": "Banco John Deere S.A."
  },
  {
    "value": "218",
    "label": "Banco BS2 S.A."
  },
  {
    "value": "222",
    "label": "Banco Credit Agrícole Brasil S.A."
  },
  {
    "value": "224",
    "label": "Banco Fibra S.A."
  },
  {
    "value": "233",
    "label": "Banco Cifra S.A."
  },
  {
    "value": "237",
    "label": "Banco Bradesco S.A."
  },
  {
    "value": "241",
    "label": "Banco Clássico S.A."
  },
  {
    "value": "243",
    "label": "Banco Máxima S.A."
  },
  {
    "value": "246",
    "label": "Banco ABC Brasil S.A."
  },
  {
    "value": "249",
    "label": "Banco Investcred Unibanco S.A."
  },
  {
    "value": "250",
    "label": "BCV - Banco de Crédito e Varejo S/A"
  },
  {
    "value": "253",
    "label": "Bexs Corretora de Câmbio S/A"
  },
  {
    "value": "254",
    "label": "Parana Banco S. A."
  },
  {
    "value": "260",
    "label": "Nu Pagamentos S.A."
  },
  {
    "value": "265",
    "label": "Banco Fator S.A."
  },
  {
    "value": "266",
    "label": "Banco Cédula S.A."
  },
  {
    "value": "268",
    "label": "Barigui Companhia Hipotecária"
  },
  {
    "value": "269",
    "label": "HSBC Brasil S.A. Banco de Investimento"
  },
  {
    "value": "271",
    "label": "IB Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
  },
  {
    "value": "300",
    "label": "Banco de la Nacion Argentina"
  },
  {
    "value": "318",
    "label": "Banco BMG S.A."
  },
  {
    "value": "320",
    "label": "China Construction Bank (Brasil) Banco Múltiplo S/A"
  },
  {
    "value": "341",
    "label": "Itaú Unibanco  S.A."
  },
  {
    "value": "366",
    "label": "Banco Société Générale Brasil S.A."
  },
  {
    "value": "370",
    "label": "Banco Mizuho do Brasil S.A."
  },
  {
    "value": "376",
    "label": "Banco J. P. Morgan S. A."
  },
  {
    "value": "389",
    "label": "Banco Mercantil do Brasil S.A."
  },
  {
    "value": "394",
    "label": "Banco Bradesco Financiamentos S.A."
  },
  {
    "value": "399",
    "label": "Kirton Bank S.A. - Banco Múltiplo"
  },
  {
    "value": "412",
    "label": "Banco Capital S. A."
  },
  {
    "value": "422",
    "label": "Banco Safra S.A."
  },
  {
    "value": "456",
    "label": "Banco MUFG Brasil S.A."
  },
  {
    "value": "464",
    "label": "Banco Sumitomo Mitsui Brasileiro S.A."
  },
  {
    "value": "473",
    "label": "Banco Caixa Geral - Brasil S.A."
  },
  {
    "value": "477",
    "label": "Citibank N.A."
  },
  {
    "value": "479",
    "label": "Banco ItauBank S.A."
  },
  {
    "value": "487",
    "label": "Deutsche Bank S.A. - Banco Alemão"
  },
  {
    "value": "488",
    "label": "JPMorgan Chase Bank, National Association"
  },
  {
    "value": "492",
    "label": "ING Bank N.V."
  },
  {
    "value": "494",
    "label": "Banco de La Republica Oriental del Uruguay"
  },
  {
    "value": "495",
    "label": "Banco de La Provincia de Buenos Aires"
  },
  {
    "value": "505",
    "label": "Banco Credit Suisse (Brasil) S.A."
  },
  {
    "value": "545",
    "label": "Senso Corretora de Câmbio e Valores Mobiliários S.A."
  },
  {
    "value": "600",
    "label": "Banco Luso Brasileiro S.A."
  },
  {
    "value": "604",
    "label": "Banco Industrial do Brasil S.A."
  },
  {
    "value": "610",
    "label": "Banco VR S.A."
  },
  {
    "value": "611",
    "label": "Banco Paulista S.A."
  },
  {
    "value": "612",
    "label": "Banco Guanabara S.A."
  },
  {
    "value": "613",
    "label": "Omni Banco S.A."
  },
  {
    "value": "623",
    "label": "Banco Pan S.A."
  },
  {
    "value": "626",
    "label": "Banco Ficsa S. A."
  },
  {
    "value": "630",
    "label": "Banco Intercap S.A."
  },
  {
    "value": "633",
    "label": "Banco Rendimento S.A."
  },
  {
    "value": "634",
    "label": "Banco Triângulo S.A."
  },
  {
    "value": "637",
    "label": "Banco Sofisa S. A."
  },
  {
    "value": "641",
    "label": "Banco Alvorada S.A."
  },
  {
    "value": "643",
    "label": "Banco Pine S.A."
  },
  {
    "value": "652",
    "label": "Itaú Unibanco Holding S.A."
  },
  {
    "value": "653",
    "label": "Banco Indusval S. A."
  },
  {
    "value": "654",
    "label": "Banco A. J. Renner S.A."
  },
  {
    "value": "655",
    "label": "Banco Votorantim S.A."
  },
  {
    "value": "707",
    "label": "Banco Daycoval S.A."
  },
  {
    "value": "712",
    "label": "Banco Ourinvest S.A."
  },
  {
    "value": "719",
    "label": "Banif - Bco Internacional do Funchal (Brasil) S.A."
  },
  {
    "value": "735",
    "label": "Banco Neon S.A."
  },
  {
    "value": "739",
    "label": "Banco Cetelem S.A."
  },
  {
    "value": "741",
    "label": "Banco Ribeirão Preto S.A."
  },
  {
    "value": "743",
    "label": "Banco Semear S.A."
  },
  {
    "value": "745",
    "label": "Banco Citibank S.A."
  },
  {
    "value": "746",
    "label": "Banco Modal S.A."
  },
  {
    "value": "747",
    "label": "Banco Rabobank International Brasil S.A."
  },
  {
    "value": "748",
    "label": "Banco Cooperativo Sicredi S. A."
  },
  {
    "value": "751",
    "label": "Scotiabank Brasil S.A. Banco Múltiplo"
  },
  {
    "value": "752",
    "label": "Banco BNP Paribas Brasil S.A."
  },
  {
    "value": "753",
    "label": "Novo Banco Continental S.A. - Banco Múltiplo"
  },
  {
    "value": "754",
    "label": "Banco Sistema S.A."
  },
  {
    "value": "755",
    "label": "Bank of America Merrill Lynch Banco Múltiplo S.A."
  },
  {
    "value": "756",
    "label": "Banco Cooperativo do Brasil S/A - Bancoob"
  },
  {
    "value": "757",
    "label": "Banco Keb Hana do Brasil S. A."
  }
];
